import * as angular from "angular";
import * as _ from "lodash";
import {PredefinedSkillType} from "../../skills/types/predefined-skill.type";
import {VehicleType} from "../../commons/types/vehicle.type";
import * as moment from "moment";
import {AddressesService} from "../../addresses/services/addresses-service.factory";
import {IQService, ITimeoutService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {AttachmentsService} from "../../attachments/services/attachments-service.service";
import {CustomersAlerts} from "../../customers/services/customers-alerts.service";
import {CustomersRequests} from "../../customers/services/customers-requests.service";
import {CustomerService} from "../../customers/services/customers-service.service";
import {OrderRequestsService} from "../../orders/services/order-requests.service";
import {OrdersService} from "../../orders/services/orders-service.service";
import {DeliveriesAlertsService} from "./deliveries-alerts.service";
import {DeliveriesRequestsService} from "./deliveries-requests.service";
import {DeliveriesService} from "./deliveries-service.service";
import {ServicesService} from "./services-service.service";
import {OmsOrdersAlertsService} from "../../oms/services/oms-orders-alerts.service";
import {ThreePLProviderType} from "../../threePL/types/threePL-provider.type";
import {FulfillmentStepRequestsService} from "../../fulfillment/services/fulfillment-step-requests.service";
import {OmsRequestsService} from "../../oms/services/oms-requests.service";
import {LeanPlanningAlertsService} from "../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningRequestsService} from "../../lean-planning/services/plan-requests.factory";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {SiteContextService} from "../../commons/services/site-context.service";
import {PricePlanBundleRequestsService} from "../../price-plan/services/price-plan-bundle-requests.service";
import {FulfillmentAlertsService} from "../../fulfillment/services/fulfillment-alerts.service";
import {FulfillmentService} from "../../fulfillment/services/fulfillment-service.service";
import {ScheduleService} from "../../schedule/services/schedule-service.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {TaskModel} from "../../tasks/models/task.model";
import {PackageConfigurationService} from "../../site-preferences/services/package-configuration-service.service";
import {FulfillmentStepModel} from "../../fulfillment/models/fulfillment-step.model";
import {AgentModel} from "../../agents/angular/models/agent.model";
import {AssignIgnoreScoreOptionType} from "../types/assign-ignore-score-option.type";
import {TaskPurposeType} from "../../commons/types/task-purpose.type";
import {EditOrderOptionsModel} from "../models/edit-order-options.model";
import {Service} from "../models/service.model";
import {ServicesFacadeService} from "../angular/services/services-facade.service";
import {take} from "rxjs";
import {ServicesViewsStateType} from "../types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../commons/services/view-settings-service.service";
import {SettingsService} from "../../site-preferences/services/settings-service.service";
import {ServicesUpdateMetadataRequestModel} from "../models/services-update-metadata-request.model";
import {MissingItemDataModel, MissingItemModel} from "../models/missing-item.model";
import {Creator} from "../../commons/models/creator.model";
import {CancellationReasonType} from "../../cancellation-reasons/types/cancellation-reason.type";
import {ActionReasonEnum} from "../../action-reasons/enums/action-reason.enum";
import {ActionReasonVisibilityEnum} from "../../action-reasons/enums/action-reason-visibility.enum";
import {createNewPackageItem, replacePackageItem} from "../../orders/utils/package-items.util";


export class DeliveriesDialogService {

  private servicesRef: any;

  /* @ngInject */
  constructor(private $mdDialog, private $mdMedia, private $log, private $task, private $q: IQService, private deliveriesRequestsService: DeliveriesRequestsService, private attachmentsService: AttachmentsService,
              private moment, private customerService: CustomerService, private $state, private customersAlerts: CustomersAlerts, private customersRequests: CustomersRequests,
              private UUIDService, private $billingAccounts, private templates, private siteContextService: SiteContextService,
              private packageConfigurationService: PackageConfigurationService,
              private $filter, private leanPlanningRequestsService: LeanPlanningRequestsService, private deliveriesService: DeliveriesService, private deliveriesAlertsService: DeliveriesAlertsService,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private $delivery, private ordersService: OrdersService, private orderRequestsService: OrderRequestsService, private omsRequestsService: OmsRequestsService,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private commonsConstants, private IAMPermissions, private servicesService: ServicesService,
              private commonsAlertsService: CommonsAlertsService, private leanPlanningAlertsService: LeanPlanningAlertsService, private splitService, private fulfillmentService: FulfillmentService, private fulfillmentAlertsService: FulfillmentAlertsService,
              private fulfillmentStepRequestsService: FulfillmentStepRequestsService, private $timeout: ITimeoutService, private servicesFacadeService: ServicesFacadeService) {
    this.servicesRef = this.$delivery();

  }

  // ******************************
  // External methods
  // ******************************

  printDelivery(service?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/delivery-print-selection-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSubmit = (purpose) => {
          self.$mdDialog.hide(purpose);
        }

      }
    });
  }

  serviceInfo(service, event?) {
    this.deliveriesService.getDeliveryBilling(service.id).then((billing) => {
      const self = this;
      return this.$mdDialog.show({
        template: require('./../views/tmpl/delivery-info-dialog.html').default,
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        fullscreen: true,
        controller: function ($scope) {
          $scope.service = service;
          $scope.billing = billing;
          $scope.cancel = self.$mdDialog.cancel;
        }
      });

    })
  }

  servicesInfo(services, event?) {

    const self = this;
    if (!services || !services.length) {
      return;
    }

    return this.$mdDialog.show({
      template: require('./../views/tmpl/services-info-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.services = angular.copy(services);
        $scope.service = angular.copy(services[0]);
        $scope.cancel = self.$mdDialog.cancel;

        $scope.getUpdatedBilling = (serviceId) => {
          $scope.loading = true;
          self.deliveriesService.getDeliveryBilling(serviceId)
            .then((billing) => {
              $scope.billing = billing;
              $scope.loading = false;
            })
        }

        $scope.onServiceSelect = (service) => {
          $scope.service = service;
          $scope.getUpdatedBilling(services[0].id);
        }

        $scope.getUpdatedBilling(services[0].id);
      }
    });
  }

  manualHandle(event, deliveryId) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/manual-handle-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesService: DeliveriesService) {

        $scope.deliveryId = deliveryId;
        $scope.note = '';

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onCancelableServicesToggled = () => {
          $scope.cancelRelatedChecked = !$scope.cancelRelatedChecked;
          $scope.calcRouted();
        }

        self.servicesRef.$asyncValues([deliveryId])
          .then((services) => {
            const relatedServiceIds = deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
            return self.servicesRef.$asyncValues(relatedServiceIds)
          })
          .then((relatedServices) => {
            const cancelableServices = relatedServices?.filter((relatedService) => {
              return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
            });
            const cancelRelatedChecked = !!cancelableServices?.length;

            $scope.cancelableServices = angular.copy(cancelableServices);
            $scope.cancelRelatedChecked = angular.copy(cancelRelatedChecked);
          });

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const cancelableServicesIds = $scope.cancelRelatedChecked ?
                _.map($scope.cancelableServices, 'id') :
                [];

              self.$mdDialog.hide({
                note: $scope.note,
                relatedIds: cancelableServicesIds
              });
            }
          }
        }

      }
    });
  }

  bulkSMS(event, ids) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/bulk-sms-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesConstants) {

        $scope.recipients = deliveriesConstants.sendSmsOptions;
        $scope.serviceIds = ids;
        $scope.selectedRecipient = undefined;
        $scope.smsTemplates = [];
        $scope.message = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onTemplateSelect = (template) => {
          $scope.message = template;
        }

        $scope.roundMessages = () => {
          return Math.ceil($scope.message.length / 160);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                message: $scope.message,
                type: $scope.selectedRecipient
              });
            }
          }
        }

        $scope._getSmsTemplates = () => {
          $scope.loading = true;
          self.deliveriesRequestsService.getBulkSMSTemplates()
            .then((smsTemplates) => {
              $scope.smsTemplates = smsTemplates;
            })
            .catch((error) => {
              self.$log.error('Failed to get sms templates from server', error);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope._getSmsTemplates();

      }
    });
  }

  createRoute(event, serviceIds) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/create-route-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $deliveries, $filter) {

        $scope.allocation = undefined;
        $scope.allocationId = undefined;
        $scope.selectedResourceData = undefined;

        $scope.loading = false;
        $scope.from = undefined;
        $scope.to = undefined;
        $scope.branchIds = [];
        $scope.skills = [];
        $scope.agentType = undefined;
        $scope.includeRouteStartEndInDispatch = !!self.siteContextService.getSiteInfo().includeRouteStartEndInDispatch;

        $scope.routePayload = {
          serviceIdList: serviceIds,
          planningResource: {
            supplyResourceSource: "Vehicle",// Allocation/Vehicle/AgentSchedule
            allocationInstanceId: undefined,
            allocationTimeWindowId: undefined,
            vehicleId: undefined
          },
          branchIds: undefined
        }

        if ($scope.includeRouteStartEndInDispatch && $scope.routePayload.planningResource.supplyResourceSource === 'Vehicle') {
          _ensureFreestyleRouteLocations();
        }

        $scope.from = undefined;
        $scope.to = undefined;

        $deliveries().$asyncValues(serviceIds)
          .then((services) => {
            $scope.services = services;
            _.forEach(services, (s) => {
              const serviceNotBeforeDate = self.moment(s.notBefore).startOf('day').valueOf();
              const serviceNotAfterDate = self.moment(s.notAfter).endOf('day').valueOf();

              $scope.from = (!$scope.from || serviceNotBeforeDate < $scope.from) ? serviceNotBeforeDate : $scope.from;
              $scope.to = (!$scope.to || serviceNotAfterDate > $scope.to) ? serviceNotAfterDate : $scope.to;
              $scope.agentType = !$scope.agentType ? _getAgentTypeByServiceType(s.serviceType) : ($scope.agentType !== $scope.agentType ? undefined : $scope.agentType);
            })
          })
          .catch((error) => {
            self.$log.error('Failed to get agent deliveries ' +
              '@deliveriesDialogService@swapDeliveries', error);
          })
          .finally(() => {
            $scope.loading = false;
          });


        $scope.cancel = self.$mdDialog.cancel;

        _initServicesQueries();

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        function _getAgentTypeByServiceType(serviceType) {
          return serviceType === 'Delivery' ? 'Driver' : 'ServiceAgent';
        }

        $scope.onRangeChange = (from, to) => {

          if (self.moment(from).isSameOrAfter(to)) {
            //"to" was changed
            if (!self.moment(to).isSame(self.moment($scope.to))) {
              $scope.from = self.moment(to).startOf('day').valueOf();
              $scope.to = self.moment(to).endOf('day').valueOf();
            }
            //"from" was changed
            else if (!self.moment(from).isSame(self.moment($scope.from))) {
              $scope.to = self.moment(from).endOf('day').valueOf();
              $scope.from = self.moment(from).startOf('day').valueOf();
            }
          } else {
            $scope.from = self.moment(from).startOf('day').valueOf();
            $scope.to = self.moment(to).endOf('day').valueOf();
          }
        }

        function _ensureFreestyleRouteLocations() {
          $scope.routePayload.planningResource.startLocation = $scope.routePayload.planningResource.startLocation || {};
          $scope.routePayload.planningResource.endLocation = $scope.routePayload.planningResource.endLocation || {};
        }

        function _clearFreestyleRouteLocations() {
          delete $scope.routePayload.planningResource.startLocation;
          delete $scope.routePayload.planningResource.endLocation;
        }

        function _applyDispatchLocationFromAccount(loc, account) {
          loc.id = _.get(account, 'id');
          loc.locationType = 'ACCOUNT';
          loc.address = _.get(account, 'address');
        }

        function _applyDispatchLocationFromDepot(loc, depot) {
          loc.id = _.get(depot, 'id');
          loc.locationType = 'DEPOT';
          loc.address = _.get(depot, 'address');
        }

        function _applyDispatchLocationFromCustomer(loc, customer) {
          loc.id = _.get(customer, 'id');
          loc.locationType = 'CUSTOMER';
          const address = _.find(_.get(customer, 'addresses'), (a) => {
            return a.id === _.get(customer, 'defaultAddressId');
          });
          loc.address = address;
        }

        $scope.onRouteTypeChange = (routeType) => {
          $scope.routePayload.planningResource.supplyResourceSource = routeType;
          $scope.routePayload.planningResource.allocationInstanceId = undefined;
          $scope.routePayload.planningResource.allocationTimeWindowId = undefined;
          $scope.routePayload.planningResource.originalId = undefined;
          $scope.routePayload.planningResource.vehicleId = undefined;
          $scope.selectedResourceData = undefined;

          if (routeType === 'Vehicle' && $scope.includeRouteStartEndInDispatch) {
            _ensureFreestyleRouteLocations();
          } else {
            _clearFreestyleRouteLocations();
          }

          if ($scope.form) {
            $scope.form.$setPristine();
            $scope.form.$setUntouched();
          }
        }

        $scope.onRouteLocationTypeChange = (locationKey, locationType) => {
          _ensureFreestyleRouteLocations();
          const loc = $scope.routePayload.planningResource[locationKey];
          loc.locationType = locationType;
          delete loc.id;
          delete loc.address;
        }

        $scope.onRouteAccountSelect = (locationKey, account) => {
          _ensureFreestyleRouteLocations();
          _applyDispatchLocationFromAccount($scope.routePayload.planningResource[locationKey], account);
        }

        $scope.onRouteDepotSelect = (locationKey, depot) => {
          _ensureFreestyleRouteLocations();
          _applyDispatchLocationFromDepot($scope.routePayload.planningResource[locationKey], depot);
        }

        $scope.onRouteCustomerSelect = (locationKey, customer) => {
          _ensureFreestyleRouteLocations();
          _applyDispatchLocationFromCustomer($scope.routePayload.planningResource[locationKey], customer);
        }

        $scope.onAllocationSelect = (allocation) => {
          $scope.allocation = allocation;
          $scope.allocationId = allocation.id;
          $scope.routePayload.planningResource.allocationInstanceId = _.get(allocation, 'id');
          $scope.routePayload.planningResource.allocationTimeWindowId = _.get(allocation, 'originalId');
          $scope.routePayload.branchIds = _.get(allocation, 'branchIds');

          var agentUser = _.get(allocation, 'agentBinding.user');
          $scope.selectedResourceData = allocation ? {
            vehicleName: _.get(allocation, 'resourceName', '---'),
            allocationName: _.get(allocation, 'resourceName', '---'),
            allocationSkills: _.get(allocation, 'requiredSkills', []),
            agentName: agentUser ? $filter('userName')(agentUser) : '---',
            startTime: _.get(allocation, 'schedule.startTime'),
            serviceAreaIds: _.get(allocation, 'serviceAreaIds', []),
            capacity: _.get(allocation, 'capacity', {}),
            branchIds: _.get(allocation, 'branchIds')
            // capacity: {
            //     weight: undefined,
            //     numberOfPackages: undefined,
            //     dimensions: {
            //         length: undefined,
            //         height: undefined,
            //         width: undefined
            //     }
            // }
          } : undefined;
        }

        $scope.onVehicleSelect = (vehicle) => {
          $scope.routePayload.planningResource.vehicleId = _.get(vehicle, 'id');
        }

        $scope.onAgentScheduleSelect = (schedule) => {
          $scope.routePayload.planningResource.allocationInstanceId = _.get(schedule, 'id');
          $scope.routePayload.planningResource.allocationTimeWindowId = _.get(schedule, 'originalId');
        }

        $scope.onBranchSelect = (branchId) => {
          $scope.routePayload.branchIds = branchId ? [branchId] : undefined;
        }

        $scope.create = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const planningResource = $scope.routePayload.planningResource;
              if (!$scope.includeRouteStartEndInDispatch || planningResource.supplyResourceSource !== 'Vehicle') {
                delete planningResource.startLocation;
                delete planningResource.endLocation;
              } else {
                _.forEach(['startLocation', 'endLocation'], (locationKey) => {
                  const loc = planningResource[locationKey];
                  if (!_.get(loc, 'id') && !_.get(loc, 'address')) {
                    delete planningResource[locationKey];
                  }
                });
              }
              self.$mdDialog.hide($scope.routePayload);
            }
          }
        }

        function _initServicesQueries() {
          $scope.loading = true;
          $deliveries().$asyncValues(serviceIds)
            .then((services) => {
              _.forEach(services, function (s) {
                if (!$scope.from || s.notBefore < $scope.from) {
                  $scope.from = s.notBefore;
                }
                if (!$scope.to || s.notAfter > $scope.to) {
                  $scope.to = s.notAfter;
                }
                $scope.branchIds = _.uniq($scope.branchIds.concat(s.branchIds || []));
                $scope.skills = _.uniq($scope.skills.concat(s.requiredSkills || []));
              })
            })
            .catch((error) => {
              // this.$log.error('Failed to get services', error);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }
      }
    });
  }

  editTaskNotes(event, task) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-task-notes-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.task = angular.copy(task);

        $scope.cancel = self.$mdDialog.cancel;
        //////////////////////

        $scope.update = () => {

          if (!_.isEqual($scope.task, task)) {
            $scope.loading = true;
            self.$task(task.id).$update($scope.task)
              .then((updatedTask) => {
                $scope.loading = false;
                self.$mdDialog.hide(updatedTask);
              })
              .catch((error) => {
                $scope.loading = false;
                self.$log.debug('Update notes failed, ' + error);
                self.$mdDialog.hide();
              })
          } else {
            self.$mdDialog.hide();
          }
        }


      }
    })
  }

  editTimeWindow(ids, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/services-edit-bulk-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesService: DeliveriesService) {

        $scope.editableServices = undefined;
        $scope.unEditableServices = undefined;
        $scope.editRelatedChecked = false;

        $scope.selectedCancellationReason = [];
        $scope.reasonTypesEntities = [CancellationReasonType.Delivery, CancellationReasonType.Operation];
        $scope.actionReasonTypes = [ActionReasonEnum.EditTimeWindow];
        $scope.actionReasonVisibiltyTypes = [ActionReasonVisibilityEnum.Admin];

        $scope.loading = false;
        $scope.serviceIds = ids;
        $scope.bulkTypeOptions = ['ChangeNotBeforeNotAfter', 'AddDays'];
        $scope.selectedBulkType = $scope.bulkTypeOptions[0];
        $scope.dayToAdd = undefined;
        $scope.isFieldServices = false;

        $scope.editScenario = {taskOrService: 'PerService'};

        $scope.rePrice = {
          enabled: false
        };

        $scope.sendSms = {
          enabled: false
        };

        $scope.pickupDate = undefined;
        $scope.pickupNotBefore = undefined;
        $scope.pickupNotAfter = undefined;

        $scope.dropoffDate = undefined;
        $scope.notBefore = moment().startOf('day').valueOf();
        $scope.notAfter = moment().endOf('day').set({
          'second': 0,
          'millisecond': 0
        }).valueOf();


        self.servicesRef.$asyncValues(ids)
          .then((services) => {
            _.forEach(services, (s) => {
              if (s.serviceType === "Operation") {
                $scope.isFieldServices = true;
              }
              // $scope.pickupDate = (!$scope.pickupDate || moment(s.notBefore).startOf('day').valueOf() < $scope.pickupDate) ? moment(s.notBefore).startOf('day').valueOf() : $scope.pickupDate;
              // $scope.dropoffDate = (!$scope.dropoffDate || moment(s.notAfter).endOf('day').valueOf() > $scope.dropoffDate) ? moment(s.notAfter).endOf('day').valueOf() : $scope.dropoffDate;
            })
            // $scope.onPickupDateChanged($scope.pickupDate);
            // $scope.onDropoffDateChanged($scope.dropoffDate);

            const relatedServiceIds = deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
            return self.servicesRef.$asyncValues(relatedServiceIds)
          })
          .then((relatedServices) => {

            $scope.editableServices = relatedServices.filter((relatedService) => {
              return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
            });

            $scope.unEditableServices = _.differenceBy(relatedServices, $scope.editableServices);

            $scope.editRelatedChecked = !!$scope.editableServices.length;
            $scope.loading = false;
          });


        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onEditableServicesToggled = () => {
          $scope.editRelatedChecked = !$scope.editRelatedChecked;
        }

        $scope.onPickupDateChanged = (selectedDate) => {
          $scope.pickupDate = selectedDate;
          if ($scope.pickupNotBefore) {
            $scope.pickupNotBefore = self.moment($scope.pickupNotBefore).set({
              'year': self.moment(selectedDate).year(),
              'month': self.moment(selectedDate).month(),
              'date': self.moment(selectedDate).date()
            }).valueOf();
          } else {
            $scope.pickupNotBefore = self.moment(selectedDate).startOf('day').set({
              'minute': 0,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }

          if ($scope.pickupNotAfter) {
            $scope.pickupNotAfter = self.moment($scope.pickupNotAfter).set({
              'year': self.moment(selectedDate).year(),
              'month': self.moment(selectedDate).month(),
              'date': self.moment(selectedDate).date()
            }).valueOf();
          } else {
            $scope.pickupNotAfter = self.moment(selectedDate).startOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }
        }

        $scope.onDropoffDateChanged = (selectedDate) => {
          $scope.dropoffDate = selectedDate;
          if ($scope.notBefore) {
            $scope.notBefore = self.moment($scope.notBefore).set({
              'year': self.moment(selectedDate).year(),
              'month': self.moment(selectedDate).month(),
              'date': self.moment(selectedDate).date()
            }).valueOf();
          } else {
            $scope.notBefore = self.moment(selectedDate).endOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }
          if ($scope.notAfter) {
            $scope.notAfter = self.moment($scope.notAfter).set({
              'year': self.moment(selectedDate).year(),
              'month': self.moment(selectedDate).month(),
              'date': self.moment(selectedDate).date()
            }).valueOf();
          } else {
            $scope.notAfter = self.moment($scope.notBefore).set({
              'year': self.moment($scope.notBefore).year(),
              'month': self.moment($scope.notBefore).month(),
              'date': self.moment($scope.notBefore).date(),
              'minute': 59,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }
        }


        $scope.onChangeReason = (actionReason) => {
          $scope.actionReason = actionReason;
        }

        $scope.onPickupNotBeforeTimeChange = (notBefore) => {
          $scope.pickupDate = notBefore;
          $scope.pickupNotBefore = notBefore;
        }

        $scope.onPickupNotAfterTimeChange = (notAfter) => {
          $scope.pickupNotAfter = notAfter;
        }

        $scope.onDropoffNotBeforeTimeChange = (notBefore) => {
          $scope.dropoffDate = notBefore;
          $scope.notBefore = notBefore;
        }

        $scope.onDropoffNotAfterTimeChange = (notAfter) => {
          $scope.notAfter = notAfter;
        }

        $scope.onDayToAddChange = (count) => {
          $scope.dayToAdd = count;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload: any = {
                dateEdit: {
                  type: $scope.selectedBulkType,
                  pickupNotBefore: undefined,
                  pickupNotAfter: undefined,
                  notBefore: undefined,
                  notAfter: undefined,
                  dayToAdd: undefined
                }
              };

              if ($scope.actionReason) {
                payload.actionReason = $scope.actionReason;
              }

              if ($scope.selectedBulkType === 'ChangeNotBeforeNotAfter') {
                _.set(payload.dateEdit, 'notBefore', $scope.notBefore);
                _.set(payload.dateEdit, 'notAfter', $scope.notAfter)
                if ($scope.editScenario.taskOrService === 'PerTask') {
                  _.set(payload.dateEdit, 'pickupNotBefore', $scope.pickupNotBefore);
                  _.set(payload.dateEdit, 'pickupNotAfter', $scope.pickupNotAfter);
                }

              } else if ($scope.selectedBulkType === 'AddDays') {
                _.set(payload.dateEdit, 'dayToAdd', $scope.dayToAdd)
              }

              let editableServicesIds = [];
              if ($scope.editRelatedChecked) {
                editableServicesIds = _.map($scope.editableServices, (s) => {
                  return s.id
                })
              }

              self.$mdDialog.hide({
                editData: payload,
                reprice: $scope.rePrice.enabled,
                sendSms: $scope.sendSms.enabled,
                editableServicesIds: editableServicesIds
              });
            }
          }
        }

        // $scope.submit = (form) => {
        //   if (form) {
        //     form.$setSubmitted(true);
        //     if (form.$valid) {
        //       var payload = {
        //         dateEdit: {
        //           type: $scope.selectedBulkType,
        //           dayToAdd: undefined,
        //           notBefore: undefined,
        //           notAfter: undefined
        //         }
        //       };
        //       if ($scope.selectedBulkType === 'AddDays') {
        //         _.set(payload.dateEdit, 'dayToAdd', $scope.dayToAdd)
        //       } else {
        //         _.set(payload.dateEdit, 'notBefore', $scope.notBefore);
        //         _.set(payload.dateEdit, 'notAfter', $scope.notAfter)
        //       }
        //
        //       let editableServicesIds = [];
        //       if ($scope.editRelatedChecked) {
        //         editableServicesIds = _.map($scope.editableServices, (s) => {
        //           return s.id
        //         })
        //       }
        //
        //       this.$mdDialog.hide({
        //         editData: payload,
        //         reprice: $scope.rePrice.enabled,
        //         editableServicesIds: editableServicesIds
        //       });
        //     }
        //   }
        // }

      }
    })
  }

  importDeliveries(event, account, schemas) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/import-deliveries-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, deliveriesConstants) {

        $scope.loading = false;
        $scope.accountId = _.get(account, 'id');
        $scope.file = undefined;
        $scope.resolveAddresses = {
          isEnabled: true
        };
        $scope.schemaOptionsWrapper = {
          list: schemas.map(s => {
            return {id: s.id, name: s.schemaName}
          }), propertyRef: 'name'
        };

        // Init Default Account
        if (account) {
          $scope.favouriteAccountName = _.get(account, 'name');
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope.accountId = _.get(account, 'id');
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onDownloadExample = () => {
          var downloadUrl = deliveriesConstants.importDeliveriesSampleFileLink;
          var a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-deliveries-example.xls";
          document.body.appendChild(a);
          a.click();
        }

        $scope.onSelectSchema = (schemaId) => {
          $scope.schemaId = schemaId;
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;

            self.deliveriesRequestsService.uploadDeliveriesExcel($scope.file, $scope.accountId, $scope.resolveAddresses.isEnabled, $scope.schemaId)
              .then((response) => {
                self.$mdDialog.hide(response);
              })
              .catch((error) => {
                self.deliveriesAlertsService.uploadError();
                self.$log.error('Failed to upload excel to server, ' +
                  'deliveriesFileDropUpload@uploadFiles' + error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }


      }
    })
  }

  leanPlanning(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/lean-planning-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $log) {

        $scope.loading = true;
        $scope.today = new Date();
        $scope.dayName = self.moment().format('dddd');
        $scope.query = {
          date: $scope.today,
          serviceAreaIds: [],
          considerServiceArea: undefined,
          onlyInStore: undefined,
          considerTimeWindows: undefined,
          numberOfServicePerRoute: undefined,
          selectedTimeSlot: undefined,
          onlyUnRouted: undefined
        };
        $scope.timeSlotMap = {};
        $scope.serviceAreaList = [];

        self.deliveriesRequestsService.getAnalysisConfiguration()
          .then((response) => {
            $scope.query = {
              date: $scope.today,
              serviceAreaIds: [],
              considerServiceArea: response.considerServiceArea,
              considerTimeWindows: response.considerTimeWindows,
              onlyInStore: _.get(response, 'onlyInStore', false),
              numberOfServicePerRoute: response.numberOfServicePerRoute,
              selectedTimeSlot: response.timeSlotMap[$scope.dayName][0],
              onlyUnRouted: response.onlyUnRouted
            };
            $scope.timeSlotMap = response.timeSlotMap;
          })
          .catch((error) => {
            self.$log.error('Failed to get configuration from server ' +
              '@deliveriesDialogService@leanPlanning', error);
          })
          .finally(() => {
            $scope.loading = false;
          });


        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.onChangeServiceAreas = (serviceAreas) => {
          $scope.serviceAreaList = serviceAreas;
        }

        $scope.onDateChange = (date) => {
          $scope.dayName = self.moment(date).format('dddd');
          $scope.query.selectedTimeSlot = $scope.timeSlotMap[$scope.dayName][0]
        }

        $scope.submit = (form) => {

          form.$setSubmitted(true);

          var queryCopy = angular.copy($scope.query);
          var timeSlotRef = $scope.query.selectedTimeSlot;

          if (form.$valid) {
            if ($scope.serviceAreaList.length) {
              queryCopy.serviceAreaIds = _.map($scope.serviceAreaList, function (area) {
                return area.areaId
              });
            }
            queryCopy.date = {
              from: self.moment($scope.query.date).hour(timeSlotRef.fromHour).minute(timeSlotRef.fromMinute).second(0).millisecond(0).valueOf(),
              to: self.moment($scope.query.date).hour(timeSlotRef.toHour).minute(timeSlotRef.toMinute).second(0).millisecond(0).valueOf()
            };
            self.$mdDialog.hide(queryCopy);
          }
        }

      }
    })
  }

  autoAssignToAgentRelatedServices(event, serviceIds, relatedServicesIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/auto-assign-related-services-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.serviceIds = serviceIds;
        $scope.relatedServicesIds = relatedServicesIds;
        $scope.assignableServiceIds = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************
        $scope.onAssignableServicesChanged = (assignableServicesIds) => {
          $scope.assignableServiceIds = assignableServicesIds;
        }

        $scope.onAssign = () => {
          self.$mdDialog.hide({
            assignableServicesIds: $scope.assignableServiceIds,
          });
        }

      }
    })
  }

  assignToAgent(event, serviceIds, isRouted, highPriorityAgentsIds?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/assign-agent-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.serviceIds = serviceIds;
        $scope.isRouted = isRouted;
        const assignIgnoreScoreOption = self.siteContextService.getSiteInfo().assignIgnoreScoreOption;
        $scope.isShowAllToggleVisible = true;

        if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
          $scope.isIgnoreScore = true;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
          $scope.isIgnoreScore = false;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
          $scope.isIgnoreScore = false;
          $scope.isShowAllToggleVisible = false;
        }

        $scope.removeServiceFromRoute = {
          enabled: true
        }

        $scope.highPriorityAgentsIds = highPriorityAgentsIds;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onToggleIsIgnoreScore = (isIgnoreScore: boolean) => {
          $scope.isIgnoreScore = isIgnoreScore;
        }

        $scope.onAssign = (agent, relatedServicesIds, doForce) => {
          self.$mdDialog.hide({
            agent: agent,
            agentId: _.get(agent, 'id'),
            relatedServicesIds: relatedServicesIds,
            doForce: doForce,
            removeServiceFromRoute: $scope.removeServiceFromRoute.enabled
          });
        }

      }
    })
  }

  multipleAssignToAgent(event, steps: FulfillmentStepModel[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/multiple-assign-agent-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.steps = angular.copy(steps);
        $scope.excludedStepIds = [];
        $scope.isAutoSelect = true;

        const assignIgnoreScoreOption = self.siteContextService.getSiteInfo().assignIgnoreScoreOption;
        $scope.isShowAllToggleVisible = true;

        if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
          $scope.isIgnoreScore = true;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
          $scope.isIgnoreScore = false;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
          $scope.isIgnoreScore = false;
          $scope.isShowAllToggleVisible = false;
        }

        $scope.setSelectedStepsData = (selectedSteps: FulfillmentStepModel[]) => {
          $scope.selectedSteps = selectedSteps;
          $scope.selectedStepIds = selectedSteps.map((s: FulfillmentStepModel) => s.id);
        }

        $scope.getSelectedStepsServicesIds = (steps) => {
          return _.chain(steps)
            .filter(s => {
              return s.attempts
            })
            .map(s => {
              return _.find(s.attempts, attempt => {
                return attempt.id === s.referenceId;
              }).id
            })
            .value()
        }

        $scope.setAutoSelectedStep = () => {
          const step = $scope.steps.find((s: FulfillmentStepModel) => {
            return !$scope.excludedStepIds.includes(s.id);
          })
          if (step) {
            const selectedSteps = [step];
            $scope.setSelectedStepsData(selectedSteps);
          }
          $scope.serviceIds = $scope.getSelectedStepsServicesIds($scope.selectedSteps);
        }

        $scope.setAutoSelectedStep();

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onToggleAutoSelect = () => {
          $scope.isAutoSelect = !$scope.isAutoSelect;
        }

        $scope.onToggleIsIgnoreScore = (isIgnoreScore: boolean) => {
          $scope.isIgnoreScore = isIgnoreScore;
        }

        $scope.onSelectStep = (step: FulfillmentStepModel) => {
          const selectedStepsCopy = angular.copy($scope.selectedSteps);

          const stepIndex = $scope.selectedSteps.findIndex((s: FulfillmentStepModel) => s.id === step.id);

          if (stepIndex > -1) {
            selectedStepsCopy.splice(stepIndex, 1);
          } else {
            selectedStepsCopy.push(step);
          }

          $scope.setSelectedStepsData(selectedStepsCopy);

          if ($scope.selectedSteps.length) {
            self.$timeout(() => {
              $scope.serviceIds = $scope.getSelectedStepsServicesIds($scope.selectedSteps);
            }, 1500);
          } else {
            $scope.serviceIds = [];
          }
        }


        $scope.onAssign = (agent: AgentModel, doForce: boolean) => {

          const serviceIdsCopy = angular.copy($scope.serviceIds);
          $scope.excludedStepIds = _.uniq($scope.excludedStepIds.concat($scope.selectedStepIds));
          const excludedStepIdsCopy = angular.copy($scope.excludedStepIds);

          $scope.serviceIds = [];

          $scope.setSelectedStepsData([]);


          if ($scope.isAutoSelect) {
            $scope.setAutoSelectedStep();
          }

          self.servicesService.assignServiceToAgent(serviceIdsCopy, agent.id, doForce)
            .then(() => {
              const stepsCopy = angular.copy($scope.steps);

              $scope.excludedStepIds.forEach((id: string) => {
                const stepIndex = stepsCopy.findIndex((s: FulfillmentStepModel) => s.id === id);
                if (stepIndex > -1) {
                  stepsCopy.splice(stepIndex, 1);
                }
              });

              $scope.steps = stepsCopy;
            })
            .finally(() => {
              $scope.excludedStepIds = $scope.excludedStepIds.filter((id: string) => !excludedStepIdsCopy.includes(id));

              if (!$scope.steps.length) {
                self.$mdDialog.hide();
              }
            })
        }

      }
    })
  }

  reset(event, serviceIds, serviceType) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/reset-services-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.serviceIds = serviceIds;
        $scope.selectedServices = undefined;
        $scope.resettableServices = undefined;
        $scope.unResettableServices = undefined;
        $scope.resetRelatedServicesChecked = undefined;
        $scope.loading = true;
        $scope.isRouted;
        $scope.resetRoutedChecked = false;

        $scope.calcRouted = () => {
          $scope.isRouted = false;
          let totalServices = $scope.selectedServices;
          if ($scope.resetRelatedServicesChecked) {
            totalServices = _.union($scope.selectedServices, $scope.resettableServices)
          }
          _.forEach(totalServices, service => {
            if (service.routeId) {
              $scope.isRouted = true;
              return;
            }
          })

        };

        self.servicesFacadeService.selectByIds(serviceIds).pipe(take(1)).subscribe((services) => {
          if (!!services.length) {
            $scope.selectedServices = services;
            const relatedServiceIds = self.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
            self.servicesRef.$asyncValues(relatedServiceIds)
              .then((relatedServices) => {


                const resettableServices = relatedServices.filter((relatedService) => {
                  return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
                });

                const unResettableServices = _.differenceBy(relatedServices, $scope.resettableServices);

                $scope.resettableServices = angular.copy(resettableServices);
                $scope.unResettableServices = angular.copy(unResettableServices);

                $scope.resetRelatedServicesChecked = !!$scope.resettableServices.length;
                $scope.loading = false;

                $scope.calcRouted();

                if ($scope.isRouted) {
                  $scope.resetRoutedChecked = true;
                }

              });
          } else {
            self.servicesRef.$asyncValues(serviceIds)
              .then((services) => {
                $scope.selectedServices = services;
                const relatedServiceIds = self.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
                return self.servicesRef.$asyncValues(relatedServiceIds)
              })
              .then((relatedServices) => {


                $scope.resettableServices = relatedServices.filter((relatedService) => {
                  return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
                });

                $scope.unResettableServices = _.differenceBy(relatedServices, $scope.resettableServices);
                $scope.resetRelatedServicesChecked = !!$scope.resettableServices.length;
                $scope.loading = false;

                $scope.calcRouted();

                if ($scope.isRouted) {
                  $scope.resetRoutedChecked = true;
                }

              });

          }
        })

        // ******************************
        //        Public methods
        // ******************************
        $scope.onResetRoutedChecked = () => {
          $scope.resetRoutedChecked = !$scope.resetRoutedChecked;
        }

        $scope.onResettableServicesChecked = () => {
          $scope.resetRelatedServicesChecked = !$scope.resetRelatedServicesChecked;
          $scope.calcRouted();

        }


        $scope.cancel = self.$mdDialog.cancel;


        $scope.onReset = () => {
          const resettableServicesIds = _.map($scope.resettableServices, (s) => {
            return s.id
          })
          self.$mdDialog.hide({
            relatedServicesIds: $scope.resetRelatedServicesChecked ? resettableServicesIds : [],
            removeFromRoute: $scope.resetRoutedChecked
          });
        }

      }
    })


  }

  assignToRoute(event, serviceIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/assign-route-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.serviceIds = serviceIds;
        $scope.mode = undefined;
        $scope.assignedRoute = undefined;
        $scope.assignAddedDeliveries = true;
        $scope.routedServicesIds = serviceIds;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onAssign = (route, routedServicesIds) => {
          $scope.assignedRoute = route;
          $scope.routedServicesIds = routedServicesIds
        }

        $scope.onFinish = () => {
          self.$mdDialog.hide({ serviceIds: $scope.routedServicesIds, routeId: $scope.assignedRoute.id });
        }

      }
    })
  }

  assignToResourceAllocation(event, serviceIds, hideUnrouted?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/assign-resource-allocation-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.isNotMobile = self.$mdMedia('gt-xs');
        $scope.isAssignAgentScenario = false;
        $scope.isLoading = undefined;
        $scope.assignToRelatedAgent = {enabled: true}
        $scope.isAssignToRelatedAgentDisabled = false;
        $scope.assignServices = true;
        $scope.VehicleType = VehicleType;
        $scope.onlyOptimized = true;
        $scope.hideUnrouted = hideUnrouted || false;

        $scope.init = () => {
          $scope.serviceIds = serviceIds;
          $scope.selectedResourceAllocationData = undefined;
          $scope.createdRoute = undefined;
          $scope.mainVehicle = undefined;
          $scope.attachedVehicle = undefined;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.init();
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onForceAddingChanged = (isForceAdding) => {
          $scope.onlyOptimized = !isForceAdding;
        }

        $scope.onToggleIsIgnoreScore = (isIgnoreScore: boolean) => {
          $scope.isIgnoreScore = isIgnoreScore;
        }

        $scope.onResourceAllocationSelected = (resourceAllocationData) => {
          if (!resourceAllocationData) {
            return;
          }
          $scope.selectedResourceAllocationData = resourceAllocationData;
          //reset defaults
          $scope.assignToRelatedAgent = {enabled: true};
          $scope.isAssignToRelatedAgentDisabled = false;
          $scope.mainVehicle = undefined;
          $scope.attachedVehicle = undefined;

          const routeStatus = _.get($scope.selectedResourceAllocationData, 'route.status')
          const noAgent = !_.get($scope.selectedResourceAllocationData, 'route.agentReference') && !_.get($scope.selectedResourceAllocationData.supplyResource, 'agentReference');

          //no agent or route started
          if (noAgent || (!!routeStatus && routeStatus === 'Started')) {
            $scope.isAssignToRelatedAgentDisabled = true;
            if (noAgent) {
              $scope.assignToRelatedAgent.enabled = false;
            }
            if (!!routeStatus && routeStatus === 'Started') {
              $scope.assignToRelatedAgent.enabled = true;
            }
          }

        }

        $scope.onAddToAllocation = (onlyOptimized) => {
          $scope._createOrAddRoute(onlyOptimized)
            .then((route) => {
              $scope.serviceIds.length > 1 ? self.deliveriesAlertsService.addToResourceAllocationMultiSuccess() : self.deliveriesAlertsService.addToResourceAllocationSuccess();
              self.$mdDialog.hide({ routeId: route?.id, serviceIds: $scope.serviceIds });
            })
            .catch((error) => {
              if (error) {
                if (error.code === 400415) {
                  self.leanPlanningAlertsService.assignRouteCannotBeCreatedError()
                    .then((res) => {
                      if (!!res) {
                        $scope.onAddToAllocation(false);
                      }
                    });
                } else {
                  $scope.serviceIds.length > 1 ? self.deliveriesAlertsService.addToResourceAllocationMultiError() : self.deliveriesAlertsService.addToResourceAllocationError();
                  $scope.init();
                }
                self.$log.error('Failed to add deliveries to resource allocation', error);
              }
            })
            .finally(() => {
              $scope.isLoading = false;
            })
        }

        $scope.onAddToAllocationAndMoveToAssign = (onlyOptimized) => {
          $scope._createOrAddRoute(onlyOptimized)
            .then((route) => {
              $scope.isLoading = false;
              $scope.createdRoute = route;
              $scope.isAssignAgentScenario = true;
              $scope.serviceIds.length > 1 ? self.deliveriesAlertsService.addToResourceAllocationMultiSuccess() : self.deliveriesAlertsService.addToResourceAllocationSuccess();
            })
            .catch((error) => {
              $scope.isLoading = false;
              if (error) {
                if (error.code === 400415) {
                  self.leanPlanningAlertsService.assignRouteCannotBeCreatedError()
                    .then((res) => {
                      if (!!res) {
                        $scope.onAddToAllocationAndMoveToAssign(false);
                      }
                    });
                } else {
                  $scope.serviceIds.length > 1 ? self.deliveriesAlertsService.addToResourceAllocationMultiError() : self.deliveriesAlertsService.addToResourceAllocationError();
                }
                self.$log.error('Failed to add deliveries to resource allocation', error);
              }
            })
        }

        $scope.onAttachedVehicleChanged = (logisticsVehicle) => {
          $scope.attachedVehicle = logisticsVehicle;
        }

        $scope.onMainVehicleChanged = (logisticsVehicle) => {
          $scope.mainVehicle = logisticsVehicle;
        }

        $scope.onAssignAgentToRoute = (agent, doForce) => {
          $scope.isLoading = true;
          //todo ben add doForce after server is ready
          self.leanPlanningRequestsService.assignRouteToAgent($scope.createdRoute.rid, _.get(agent, 'id'), $scope.assignServices)
            .then(() => {
              self.leanPlanningAlertsService.assignSuccess();
              self.$mdDialog.hide({ routeId: $scope.selectedResourceAllocationData.route.id, serviceIds: $scope.serviceIds });
            })
            .catch((error) => {
              if (error) {
                self.leanPlanningAlertsService.assignError();
                self.$log.error('Failed to assign route to driver', error);
              } else {
                self.$log.info('Dialog Closed');
              }
            })
            .finally(() => {
              $scope.isLoading = false;
            })
        }

        $scope.cancelAssign = () => {
          self.$mdDialog.hide({ routeId: '', serviceIds: $scope.serviceIds });
        }

        $scope._createOrAddRoute = (onlyOptimized) => {
          $scope.isLoading = true;

          let attachedVehicleToUpdate = undefined;
          let mainVehicleToUpdate = undefined;
          if ($scope.mainVehicle) {
            mainVehicleToUpdate = {id: $scope.mainVehicle.id, vehicleType: $scope.mainVehicle.vehicleTypeReference.type}
          }
          if ($scope.attachedVehicle) {
            attachedVehicleToUpdate = {
              id: $scope.attachedVehicle.id,
              vehicleType: $scope.attachedVehicle.vehicleTypeReference.type
            }
          }
          return self.deliveriesRequestsService.addServicesToResource(
            $scope.serviceIds,
            $scope.assignToRelatedAgent.enabled,
            $scope.selectedResourceAllocationData.supplyResource.id,
            $scope.selectedResourceAllocationData.supplyResource.resourceEventEntityId,
            $scope.selectedResourceAllocationData.supplyResource.type,
            onlyOptimized,
            attachedVehicleToUpdate,
            mainVehicleToUpdate,
          )
        }

      }
    })
  }

  createSimple(event, favouriteAccount) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/create-simple-deliveries-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, tasksConstants, deliveriesService: DeliveriesService, addressesService: AddressesService, $timeout: ITimeoutService, $depots, splitService: SplitService, viewSettingsService: ViewSettingsService, commonsAlertsService: CommonsAlertsService, packageConfigurationService: PackageConfigurationService) {

        $scope.cashOnDeliveryActionTypesMap = {
          Collect: true,
          Payment: true
        };

        $scope.isServiceExternalIdIsMandatory = splitService.getIsServiceExternalIdIsMandatory();

        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.configZoneId = splitService.getTimeZone();
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.useLegacyServiceTime = splitService.getUseLegacyServiceTime();

        $scope.proxyProviderType = $scope.siteInfo.proxyProviderType;
        $scope.callContactUsingProxyByDefaultValue = $scope.siteInfo.callContactUsingProxyByDefault;

        $scope.canCreateTag = self.IAMPermissions.hasPermission('infoTags.create');
        $scope.viewType = 'placeholder'; // placeholder/load/order/summary/error
        $scope.creatingOrder = false;
        $scope.account = favouriteAccount;
        $scope.billingAccount = undefined;
        $scope.pricePlanBundle = undefined;
        $scope.originalQuoteCopy = undefined;
        $scope.answers = undefined;
        $scope.textError = undefined; // In case of error while creating order;
        $scope.quotes = [];
        $scope.addressZoneId = undefined;
        $scope.order = {};
        $scope.excludedSkillsIds = [PredefinedSkillType.Delivery];
        $scope.accountDefaultDepot = undefined;

        $scope.packageTypes = [];
        $scope.vehicleTypes = [];
        $scope.identificationOptions = {
          Pickup: [],
          Dropoff: []
        };
        $scope.createAnother = {enabled: false}; // Create another delivery after creating OR escaping dialog.
        $scope.openSections = {
          Pickup: false,
          Dropoff: true,
          details: false,
          timeWindow: false
        };
        $scope.customers = {
          Pickup: undefined,
          Dropoff: undefined
        };
        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };
        $scope.customAddressEnabled = {
          Pickup: false,
          Dropoff: false
        };

        /////////////Price//////////////
        $scope.orderPrice = undefined;
        $scope.paymentMethod = undefined;
        $scope.paymentMethods = [];

        // Init Default Account
        if ($scope.account) {
          $timeout(100)
            .then(() => {
              $scope.favouriteAccountName = _.get($scope.account, 'name');
              $scope._initAccount($scope.account);
            })
        }

        viewSettingsService.getBySite(ServicesViewsStateType.DELIVERIES_FORM_STATE, ViewSettingsType.Form)
          .then((viewSettings: ViewSettingsModel[]) => {
            const userViewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
            if (userViewFormSettings) {
              $scope.viewFormSettings = userViewFormSettings
            } else {
              $scope.viewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
            }
          })

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSubTasksChanged = (task, subTasks) => {
          if (task) {
            task.subTasks = subTasks;
          }
        }

        $scope.onReferenceIdsChange = (referenceIds) => {
          $scope.order.serviceList[0].referenceIds = referenceIds;
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope._initOrder($scope.account, $scope.accountDefaultDepot, $scope.pricePlanBundle, pricePlan.type);
          $scope._loadOrderSettings($scope.order.pricePlanType);
        }

        $scope.onSelectAccount = (account: AccountModel) => {
          if (account) {
            $scope.account = account;
            $scope._initAccount(account);
          }
          // Reset Flow
          else {
            $scope.account = undefined;
            $scope.viewType = 'placeholder';

            $scope.customers = {
              Pickup: undefined,
              Dropoff: undefined
            };
            $scope.openSections = {
              Pickup: false,
              Dropoff: true,
              details: false,
              timeWindow: false
            };
            $scope.createAnother = {enabled: false};
          }
        }


        $scope.onAddressChange = (address, taskRef, taskIndex) => {
          $scope.order.serviceList[0].taskList[taskIndex].taskSpec.address = address;
          if (!_.isEmpty(address)) {
            $scope.setQuotesByDate($scope.selectedDate);
          } else {
            $scope.quotes = undefined;
            $scope.selectedQuote = undefined;
          }
        }

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope.setQuotesByDate = (date) => {
          var from = self.moment(date).startOf('day').valueOf();
          var to = self.moment(date).endOf('day').valueOf();

          var taskWithoutAddress = _.find($scope.order.serviceList[0].taskList, (task: TaskModel) => {
            return !_.get(task.taskSpec, 'address');
          });

          if (!taskWithoutAddress) {
            $scope._loadQuotes($scope.order.pricePlanType, from, to);
          } else {
            $scope.quotes = undefined;
            $scope.selectedQuote = undefined;
          }

        }

        $scope.onQuoteChange = (quote) => {
          $scope._assignQuote(quote);
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onLocationSelect = (location, taskRef, taskIndex) => {
          $scope.order.serviceList[0].taskList[taskIndex].taskSpec.address.location = addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];
          var taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
          $scope.customAddressEnabled[taskPurposeToDisableCustom] = false;

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onConvertToAdvance = (order) => {
          if (!!$scope.account) {

            if ($scope.quotes && $scope.selectedQuote) {
              $scope.selectedQuote.id = self.UUIDService.generate();
              $scope.selectedQuote.startTime = $scope.order.serviceList[0].notBefore;
              $scope.selectedQuote.endTime = $scope.order.serviceList[0].notAfter;
              $scope.quotes.push($scope.selectedQuote);
            }

            self.$state.go('accounts-detail-demand.new-delivery',
              {
                id: $scope.account.id,
                order: order,
                quotes: $scope.quotes
              });
            $scope.cancel();

          }
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
          $scope.addMarker = {
            enabledIndex: undefined,
            purpose: undefined
          };
        }

        $scope.onSummaryCustomerAnswersChange = (answers) => {
          $scope.answers = answers;
        }

        $scope.swapTasks = () => {
          self.ordersService.swapTasks($scope.order.serviceList[0]);
          _swapPurposeRefs();
        }

        $scope.onAddSubTaskToTask = (task, subtask) => {
          if (subtask.actions?.length) {
            subtask.actions = $scope._getSubTaskActionsWithDefaults(subtask);
          }

          if (task) {
            if (!task.subTasks) {
              task.subTasks = [];
            }
            task.subTasks.unshift(angular.copy(subtask));
          }
        }

        $scope.onRemoveSubtask = (task, subtask, index) => {
          if (task) {
            task.subTasks.splice(index, 1);
            if (!task.subTasks?.length) {
              task.subTasks = undefined;
            }
          }
        }

        $scope.onAddServiceAttachment = () => {
          self.deliveriesService.addDeliveryAttachments()
            .then((attachment) => {
              if (!$scope.order.serviceList[0].attachments) {
                $scope.order.serviceList[0].attachments = [];
              }

              $scope.order.serviceList[0].attachments.push(attachment);
            })
        }

        $scope.onTagsChange = (tagNames) => {
          $scope.order.serviceList[0].tagNames = tagNames;
        }

        $scope.onRemoveServiceAttachment = (index) => {
          $scope.order.serviceList[0].attachments.splice(index, 1);
        }

        $scope.onSkillsChange = (ids) => {
          $scope.order.serviceList[0].requiredSkills = ids;
        }

        $scope.onSubmit = (form) => {
          form.Pickup.$setSubmitted();
          form.Dropoff.$setSubmitted();

          if (form.$valid) {
            $scope.viewType = 'load';
            self.orderRequestsService.getOrderPrice($scope.order, $scope.order.accountId)
              .then((orderPrice) => {
                _setPrice(orderPrice);
                $scope.viewType = 'summary';
              })
              .catch((error) => {
                if (error?.code === 400306) {
                  $scope.viewType = 'order';
                  self.deliveriesAlertsService.invalidDeliveryDayError();
                  return;
                }
                if (error && error.code) {
                  $scope.viewType = 'error';
                  $scope.textError = error.code === 400301 ?
                    'alerts.DELIVERY_OUT_OF_SERVICE_ZONE_ERROR' :
                    'alerts.DELIVERY_CREATE_ERROR';
                }
              })

          } else {
            $scope.openSections = {
              Pickup: form.Pickup.$invalid,
              Dropoff: form.Dropoff.$invalid,
              details: true,
              timeWindow: false
            };
            commonsAlertsService.formInvalidInfo();
          }
        }

        $scope.onBackToOrder = () => {
          $scope.viewType = 'order';
          $scope.textError = undefined;
          $scope._setPrice();
        }

        $scope.onConfirm = () => {
          $scope.order.pmid = $scope.paymentMethod;
          $scope.viewType = 'load';
          $scope.viewType = 'load';

          if ($scope.order.serviceList[0].packageList[0]?.items?.length) {
            $scope.order.serviceList[0].packed = true;
          }
          self.orderRequestsService.placeOrder($scope.order, $scope.order.accountId)
            .then((order) => {
              if ($scope.createAnother.enabled) {
                _resetFlow();
                $scope._initOrder($scope.account, $scope.accountDefaultDepot, $scope.pricePlanBundle, $scope.defaultPricePlanTypeByServiceType);

                const todayQuote = _.find($scope.quotes, (q) => {
                  return self.moment(q.startTime).isSame(self.moment(), 'day');
                });
                $scope._assignQuote(todayQuote || _.get($scope.quotes, '[0]'));
              } else {
                self.$mdDialog.hide(order);
              }
            })
            .catch((error) => {
              self.$log.error('Failed to create order, @onConfirm', error);
            })
            .finally(() => {
              $scope.viewType = 'order';
              $scope.viewType = 'order';
            });
        }

        function _resetFlow() {
          $scope.openSections = {
            Pickup: false,
            Dropoff: true,
            details: false,
            timeWindow: false
          };
          $scope.customers = {
            Pickup: undefined,
            Dropoff: undefined
          };
        }

        $scope._initAccount = (account: AccountModel) => {
          $scope.accountDefaultDepot = undefined;
          if (account.billingAccountId) {
            $scope.viewType = 'load';
            return self.$billingAccounts(account.billingAccountId).$asyncValue()
              .then((billingAccount) => {
                $scope.billingAccount = billingAccount;
                return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id);
              })
              .then((pricePlanBundle) => {
                $scope.pricePlanBundle = pricePlanBundle;
                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.account.id, 'Delivery');
              })
              .then((defaultPricePlanTypeByServiceType) => {
                $scope.defaultPricePlanTypeByServiceType = $scope.pricePlanBundle.defaultPricePlanProgramType || _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                return account.defaultDepotId ? $depots(account.defaultDepotId).$asyncValue() : self.$q.when();
              })
              .then((defaultDepot) => {
                $scope.accountDefaultDepot = defaultDepot;
                $scope._initOrder($scope.account, defaultDepot, $scope.pricePlanBundle, $scope.defaultPricePlanTypeByServiceType);

                $scope._loadOrderSettings($scope.order.pricePlanType);

                // If account did not change then init order view.
                if ($scope.viewType === 'load') {
                  $scope.viewType = 'order';
                }
              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
              })
          } else {
            self.$log.error('Account has no billingAccountId!');
          }
        }

        $scope._loadQuotes = (selectedPricePlanType, from, to) => {

          if ($scope.order.serviceList[0].taskList[1].taskSpec?.address &&
            !!Object.keys($scope.order.serviceList[0].taskList[1].taskSpec?.address).length) {
            var services = _getServices($scope.order);

            $scope.loadingQuotes = true;
            self.ordersService.getOrderQuote(services, $scope.order.accountId, $scope.order.pricePlanType, from, to)
              .then((service) => {
                $scope.quotes = service.quotes;
                $scope.addressZoneId = _.get(service, 'destinationZoneId');

                const todayQuote = _.find(service.quotes, (q) => {
                  return self.moment(q.startTime).isSame(self.moment(), 'day');
                });
                $scope._assignQuote(todayQuote || _.get($scope.quotes, '[0]'));
              })
              .catch((error) => {
                self.$log.error('Failed to get quotes', error)
              })
              .finally(() => {
                $scope.loadingQuotes = false;
              })
          }
        }

        $scope._assignQuote = (quote) => {
          $scope.selectedQuote = angular.copy(quote);

          if (_.get(quote, 'type') === 'PerTask') {
            quote = $scope.quotes[0];
          }

          $scope.selectedDate = quote ? new Date(_.get(quote, 'startTime')) : undefined;

          self.deliveriesService.updateDeliveryQuote($scope.order.serviceList[0], quote);
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          var quoteTypes = ['Urgency', 'TimeSlot', 'DynamicTimeSlot', 'FreeStyle', 'PerTask'];

          self.ordersService.getOrderSettings($scope.order.accountId, $scope.order.serviceList[0].serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.order.serviceList[0].taskList[0].taskValidationList = undefined;
              $scope.order.serviceList[0].taskList[1].taskValidationList = undefined;
              orderSettings.enabledServiceValidations?.forEach((validation) => {

                if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Pickup)) {
                  if (!$scope.order.serviceList[0].taskList[0].taskValidationList) {
                    $scope.order.serviceList[0].taskList[0].taskValidationList = []
                  }
                  $scope.order.serviceList[0].taskList[0].taskValidationList.push(validation);
                }

                if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Dropoff)) {
                  if (!$scope.order.serviceList[0].taskList[1].taskValidationList) {
                    $scope.order.serviceList[0].taskList[1].taskValidationList = []
                  }
                  $scope.order.serviceList[0].taskList[1].taskValidationList.push(validation);
                }
              })


              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;


              $scope.packageSizes = serviceRef.itemSizeList;
              $scope.subTaskOptionsMap = {
                [TaskPurposeType.Pickup]: [],
                [TaskPurposeType.Dropoff]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(TaskPurposeType.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(TaskPurposeType.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;
              $scope.order.serviceList[0].vehicleType = _.get(serviceRef, 'defaultVehicle');
              $scope.order.serviceList[0].requiredSkills = _.get(serviceRef, 'defaultSkills', [PredefinedSkillType.Delivery]);

              if (!$scope.order.serviceList[0].requiredSkills?.length) {
                $scope.order.serviceList[0].requiredSkills = [PredefinedSkillType.Delivery];
              }

              _.forEach($scope.order.serviceList[0].taskList, (t) => {
                t.subTasks = [];
                serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                  if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                    t.subTasks.push(defaultSubTask);
                  }
                })

                t.subTasks?.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })
              })


              if (!$scope.order.serviceList[0].packageList[0].items.length) {
                var defaultItemSizeItem = _.find($scope.packageSizes, (p) => {
                  return p.itemSize === serviceRef.defaultItemSize;
                });
                $scope.order.serviceList[0].packageList[0].items.push(
                  {
                    count: 1,
                    barcode: null,
                    size: defaultItemSizeItem.itemSize || 'NoPackage',
                    labels: defaultItemSizeItem.labels || [],
                    dimensions: defaultItemSizeItem.dimensions || {},
                    weight: defaultItemSizeItem.weight
                  }
                )
              }

              $scope.identificationOptions = {
                Pickup: self.ordersService.buildIdentificationOptions(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings),
                Dropoff: self.ordersService.buildIdentificationOptions(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings),
              };

              var defaultPickupIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings);

              var defaultDropoffIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings);

              _.forEach($scope.order.serviceList[0].taskList, (t) => {
                var purpose = t.taskSpec.purpose;
                var identificationsRef = purpose === 'Pickup' ? defaultPickupIdentification : defaultDropoffIdentification;
                $scope.onIdentificationsChange(identificationsRef, t);

                // Set tasks default service time
                if (t.taskSpec.purpose === 'Pickup') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
                  }
                }
                if (t.taskSpec.purpose === 'Dropoff') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
                  }
                }
              });

            })
        }

        function _parseMinutesToMilis(minutes) {
          return minutes * 60000;
        }

        $scope._getSubTaskActionsWithDefaults = (subTask) => {
          if (!subTask.actions?.length) return [];

          return subTask.actions.map((a) => {

            if ($scope.cashOnDeliveryActionTypesMap[a.type]) {

              a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
                method: undefined,
                requestAmount: undefined,
                editable: true
              }];
            }
            return a;
          });
        }


        $scope._initOrder = (account, defaultDepot, pricePlanBundle, defaultProgramType) => {
          $scope.order = self.ordersService.getEmptyDeliveryOrder(account, defaultDepot, pricePlanBundle, defaultProgramType);
          $scope.order.serviceList[0].urgency = 'Other';
          $scope.order.serviceList[0].packageList[0].items = [];
          if ($scope.proxyProviderType !== 'Default') {
            _.forEach($scope.order.serviceList[0].taskList, task => {
              task.taskSpec.useProxyCall = $scope.callContactUsingProxyByDefaultValue;
            })
          }
        }

        function _getServices(order) {
          var services = [{
            serviceType: order.serviceList[0].serviceType,
            tasks: []
          }];
          order.serviceList[0].taskList.forEach((task: TaskModel) => {
            services[0].tasks.push({
              purpose: task.taskSpec.purpose,
              address: task.taskSpec.address
            });
          });
          return services;
        }

        function _setPrice(orderPrice) {
          $scope.orderPrice = orderPrice;
          $scope.paymentMethod = orderPrice ? $scope.billingAccount.defaultPaymentMethod : undefined;
          $scope.paymentMethods = orderPrice ? $scope.billingAccount.paymentMethods : undefined;
          $scope.order.serviceList[0].billing = _.get(orderPrice, 'serviceBillings[0]', undefined);
        }

        function _swapPurposeRefs() {
          var tmpCustomers = $scope.customers;
          $scope.customers = {
            Pickup: _.get(tmpCustomers, 'Dropoff'),
            Dropoff: _.get(tmpCustomers, 'Pickup')
          };

          var tmpCustomAddressEnabledPickup = $scope.customAddressEnabled.Pickup;
          $scope.customAddressEnabled.Pickup = $scope.customAddressEnabled.Dropoff;
          $scope.customAddressEnabled.Dropoff = tmpCustomAddressEnabledPickup;

          $scope.addMarker.enabledIndex = $scope.addMarker.enabledIndex ? ($scope.addMarker.enabledIndex === 0 ? 1 : 0) : undefined;
          $scope.addMarker = {
            enabledIndex: $scope.addMarker.enabledIndex ? ($scope.addMarker.enabledIndex === 0 ? 1 : 0) : undefined,
            purpose: $scope.addMarker.purpose === 'Pickup' ? 'Dropoff' : 'Pickup'
          }
        }

        $scope.onPackageChange = (packageItem, index) => {
          _.set(packageItem, 'size', packageItem.type);
          _.unset(packageItem, 'type');

          const itemsCopy = angular.copy($scope.order.serviceList[0].packageList[0].items);
          itemsCopy[index] = packageItem;
          $scope.order.serviceList[0].packageList[0].items = itemsCopy;
        }
      }
    })
  }

  createSimpleOperation(event, favouriteAccount) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/create-simple-operation-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, tasksConstants, deliveriesService: DeliveriesService, addressesService: AddressesService, $timeout: ITimeoutService, $depots, splitService: SplitService, viewSettingsService: ViewSettingsService, commonsAlertsService: CommonsAlertsService, packageConfigurationService: PackageConfigurationService) {

        $scope.cashOnDeliveryActionTypesMap = {
          Collect: true,
          Payment: true
        };

        $scope.isServiceExternalIdIsMandatory = splitService.getIsServiceExternalIdIsMandatory();

        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.configZoneId = splitService.getTimeZone();
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.useLegacyServiceTime = splitService.getUseLegacyServiceTime();

        $scope.proxyProviderType = $scope.siteInfo.proxyProviderType;
        $scope.callContactUsingProxyByDefaultValue = $scope.siteInfo.callContactUsingProxyByDefault;

        $scope.canCreateTag = self.IAMPermissions.hasPermission('infoTags.create');
        $scope.viewType = 'placeholder'; // placeholder/load/order/summary/error
        $scope.creatingOrder = false;
        $scope.account = favouriteAccount;
        $scope.billingAccount = undefined;
        $scope.pricePlanBundle = undefined;
        $scope.originalQuoteCopy = undefined;
        $scope.answers = undefined;
        $scope.textError = undefined; // In case of error while creating order;
        $scope.quotes = [];
        $scope.addressZoneId = undefined;
        $scope.order = {};
        $scope.excludedSkillsIds = [PredefinedSkillType.Delivery];
        $scope.accountDefaultDepot = undefined;

        $scope.packageTypes = [];
        $scope.vehicleTypes = [];
        $scope.identificationOptions = {
          Operation: []
        };
        $scope.createAnother = {enabled: false};
        $scope.openSections = {
          Operation: true,
          details: false,
          timeWindow: true
        };
        $scope.customers = {
          Operation: undefined
        };
        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };
        $scope.customAddressEnabled = {
          Operation: false
        };

        /////////////Price//////////////

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

        $scope.onConvertToAdvance = (order) => {
          if (!!$scope.account) {

            if ($scope.quotes && $scope.selectedQuote) {
              $scope.selectedQuote.id = self.UUIDService.generate();
              $scope.selectedQuote.startTime = $scope.order.serviceList[0].notBefore;
              $scope.selectedQuote.endTime = $scope.order.serviceList[0].notAfter;
              $scope.quotes.push($scope.selectedQuote);
            }

            self.$state.go('accounts-detail-demand.new-operation',
              {
                id: $scope.account.id,
                order: order,
                quotes: $scope.quotes
              });
            $scope.cancel();

          }
        }

        if (favouriteAccount) {
          $scope._initAccount(favouriteAccount);
        }

        $scope.onSelectAccount = (account: AccountModel) => {
          if (account) {
            $scope.account = account;
            $scope._initAccount(account);
          } else {
            $scope.account = undefined;
            $scope.viewType = 'placeholder';
            $scope.customers = {
              Operation: undefined
            };
            $scope.openSections = {
              Operation: true,
              details: false,
              timeWindow: false
            };
            $scope.createAnother = {enabled: false};
          }
        }

        $scope.onSubTasksChanged = (task, subTasks) => {
          if (task) {
            task.subTasks = subTasks;
          }
        }

        $scope.onReferenceIdsChange = (referenceIds) => {
          $scope.order.serviceList[0].referenceIds = referenceIds;
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope._initOrder($scope.account, $scope.accountDefaultDepot, $scope.pricePlanBundle, pricePlan.type);
          $scope._loadOrderSettings($scope.order.pricePlanType);
        }

        $scope.onAddressChange = (address, taskRef, taskIndex) => {
          $scope.order.serviceList[0].taskList[taskIndex].taskSpec.address = address;
          if (!_.isEmpty(address)) {
            $scope.setQuotesByDate($scope.selectedDate);
          } else {
            $scope.quotes = undefined;
            $scope.selectedQuote = undefined;
          }
        }

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope.setQuotesByDate = (date) => {
          var from = self.moment(date).startOf('day').valueOf();
          var to = self.moment(date).endOf('day').valueOf();

          var taskWithoutAddress = _.find($scope.order.serviceList[0].taskList, (task: TaskModel) => {
            return !_.get(task.taskSpec, 'address');
          });

          if (!taskWithoutAddress) {
            $scope._loadQuotes($scope.order.pricePlanType, from, to);
          } else {
            $scope.quotes = undefined;
            $scope.selectedQuote = undefined;
          }

        }

        $scope.onQuoteChange = (quote) => {
          $scope._assignQuote(quote);
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onLocationSelect = (location, taskRef, taskIndex) => {
          $scope.order.serviceList[0].taskList[taskIndex].taskSpec.address.location = addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
          $scope.addMarker = {
            enabledIndex: undefined,
            purpose: undefined
          };
        }

        $scope.onSummaryCustomerAnswersChange = (answers) => {
          $scope.answers = answers;
        }


        $scope.onAddSubTaskToTask = (task, subtask) => {
          if (subtask.actions?.length) {
            subtask.actions = $scope._getSubTaskActionsWithDefaults(subtask);
          }

          if (task) {
            if (!task.subTasks) {
              task.subTasks = [];
            }
            task.subTasks.unshift(angular.copy(subtask));
          }
        }

        $scope.onRemoveSubtask = (task, subtask, index) => {
          if (task) {
            task.subTasks.splice(index, 1);
            if (!task.subTasks?.length) {
              task.subTasks = undefined;
            }
          }
        }

        $scope.onAddServiceAttachment = () => {
          self.deliveriesService.addDeliveryAttachments()
            .then((attachment) => {
              if (!$scope.order.serviceList[0].attachments) {
                $scope.order.serviceList[0].attachments = [];
              }

              $scope.order.serviceList[0].attachments.push(attachment);
            })
        }

        $scope.onTagsChange = (tagNames) => {
          $scope.order.serviceList[0].tagNames = tagNames;
        }

        $scope.onRemoveServiceAttachment = (index) => {
          $scope.order.serviceList[0].attachments.splice(index, 1);
        }

        $scope.onSkillsChange = (ids) => {
          $scope.order.serviceList[0].requiredSkills = ids;
        }

        $scope.onSubmit = (form) => {
          form.Operation.$setSubmitted();

          if (form.$valid) {
            $scope.viewType = 'load';
            self.orderRequestsService.getOrderPrice($scope.order, $scope.order.accountId)
              .then((orderPrice) => {
                _setPrice(orderPrice);
                $scope.viewType = 'summary';
              })
              .catch((error) => {
                if (error?.code === 400306) {
                  $scope.viewType = 'order';
                  self.deliveriesAlertsService.invalidDeliveryDayError();
                  return;
                }
                if (error && error.code) {
                  $scope.viewType = 'error';
                  $scope.textError = error.code === 400301 ?
                    'alerts.DELIVERY_OUT_OF_SERVICE_ZONE_ERROR' :
                    'alerts.DELIVERY_CREATE_ERROR';
                }
              })

          } else {
            $scope.openSections = {
              Operation: form.Operation.$invalid,
              details: true,
              timeWindow: false
            };
            commonsAlertsService.formInvalidInfo();
          }
        }

        $scope.onBackToOrder = () => {
          $scope.viewType = 'order';
          $scope.textError = undefined;
          $scope._setPrice();
        }

        $scope.onConfirm = () => {
          $scope.order.pmid = $scope.paymentMethod;
          $scope.viewType = 'load';
          $scope.viewType = 'load';

          if ($scope.order.serviceList[0].packageList[0]?.items?.length) {
            $scope.order.serviceList[0].packed = true;
          }
          self.orderRequestsService.placeOrder($scope.order, $scope.order.accountId)
            .then((order) => {
              if ($scope.createAnother.enabled) {
                _resetFlow();
                $scope._initOrder($scope.account, $scope.accountDefaultDepot, $scope.pricePlanBundle, $scope.defaultPricePlanTypeByServiceType);

                const todayQuote = _.find($scope.quotes, (q) => {
                  return self.moment(q.startTime).isSame(self.moment(), 'day');
                });
                $scope._assignQuote(todayQuote || _.get($scope.quotes, '[0]'));
              } else {
                self.$mdDialog.hide(order);
              }
            })
            .catch((error) => {
              self.$log.error('Failed to create order, @onConfirm', error);
            })
            .finally(() => {
              $scope.viewType = 'order';
              $scope.viewType = 'order';
            });
        }

        function _resetFlow() {
          $scope.openSections = {
            Operation: true,
            details: false,
            timeWindow: false
          };
          $scope.customers = {
            Operation: undefined
          };
        }

        $scope._initAccount = (account: AccountModel) => {
          $scope.accountDefaultDepot = undefined;
          if (account.billingAccountId) {
            $scope.viewType = 'load';
            return self.$billingAccounts(account.billingAccountId).$asyncValue()
              .then((billingAccount) => {
                $scope.billingAccount = billingAccount;
                return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id);
              })
              .then((pricePlanBundle) => {
                $scope.pricePlanBundle = pricePlanBundle;
                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.account.id, 'Operation');
              })
              .then((defaultPricePlanTypeByServiceType) => {
                $scope.defaultPricePlanTypeByServiceType = $scope.pricePlanBundle.defaultPricePlanProgramType || _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                return account.defaultDepotId ? $depots(account.defaultDepotId).$asyncValue() : self.$q.when();
              })
              .then((defaultDepot) => {
                $scope.accountDefaultDepot = defaultDepot;
                $scope._initOrder($scope.account, defaultDepot, $scope.pricePlanBundle, $scope.defaultPricePlanTypeByServiceType);

                $scope._loadOrderSettings($scope.order.pricePlanType);

                // If account did not change then init order view.
                if ($scope.viewType === 'load') {
                  $scope.viewType = 'order';
                }
              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimpleOperation', error);
              })
          } else {
            self.$log.error('Account has no billingAccountId!');
          }
        }

        $scope._loadQuotes = (selectedPricePlanType, from, to) => {

          if ($scope.order.serviceList[0].taskList[0].taskSpec?.address &&
            !!Object.keys($scope.order.serviceList[0].taskList[0].taskSpec?.address).length) {
            var services = _getServices($scope.order);

            $scope.loadingQuotes = true;
            self.ordersService.getOrderQuote(services, $scope.order.accountId, $scope.order.pricePlanType, from, to)
              .then((service) => {
                $scope.quotes = service.quotes;
                $scope.addressZoneId = _.get(service, 'destinationZoneId');

                const todayQuote = _.find(service.quotes, (q) => {
                  return self.moment(q.startTime).isSame(self.moment(), 'day');
                });
                $scope._assignQuote(todayQuote || _.get($scope.quotes, '[0]'));
              })
              .catch((error) => {
                self.$log.error('Failed to get quotes', error)
              })
              .finally(() => {
                $scope.loadingQuotes = false;
              })
          }
        }

        $scope._assignQuote = (quote) => {
          $scope.selectedQuote = angular.copy(quote);

          if (_.get(quote, 'type') === 'PerTask') {
            quote = $scope.quotes[0];
          }

          $scope.selectedDate = quote ? new Date(_.get(quote, 'startTime')) : undefined;

          self.deliveriesService.updateDeliveryQuote($scope.order.serviceList[0], quote);
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          var quoteTypes = ['Urgency', 'TimeSlot', 'DynamicTimeSlot', 'FreeStyle', 'PerTask'];

          self.ordersService.getOrderSettings($scope.order.accountId, $scope.order.serviceList[0].serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.order.serviceList[0].taskList[0].taskValidationList = undefined;
              orderSettings.enabledServiceValidations?.forEach((validation) => {

                if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Operation)) {
                  if (!$scope.order.serviceList[0].taskList[0].taskValidationList) {
                    $scope.order.serviceList[0].taskList[0].taskValidationList = []
                  }
                  $scope.order.serviceList[0].taskList[0].taskValidationList.push(validation);
                }
              })


              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;


              $scope.packageSizes = serviceRef.itemSizeList;
              $scope.subTaskOptionsMap = {
                [TaskPurposeType.Operation]: []
              }

              if (serviceRef.optionalSubTasks) {
                serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                  if (optionalSubTask.purposes.includes(TaskPurposeType.Operation)) {
                    $scope.subTaskOptionsMap.Operation.push(optionalSubTask);
                  }
                })
              }

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;
              $scope.order.serviceList[0].vehicleType = _.get(serviceRef, 'defaultVehicle');
              $scope.order.serviceList[0].requiredSkills = _.get(serviceRef, 'defaultSkills', [PredefinedSkillType.Merchandise]);

              if (!$scope.order.serviceList[0].requiredSkills?.length) {
                $scope.order.serviceList[0].requiredSkills = [PredefinedSkillType.Merchandise];
              }

              _.forEach($scope.order.serviceList[0].taskList, (t) => {
                t.subTasks = [];
                if (serviceRef.defaultSubTasks) {
                  serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                    if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                      t.subTasks.push(defaultSubTask);
                    }
                  })
                }

                t.subTasks?.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })
              })


              if (!$scope.order.serviceList[0].packageList[0].items.length) {
                var defaultItemSizeItem = _.find($scope.packageSizes, (p) => {
                  return p.itemSize === serviceRef.defaultItemSize;
                });
                $scope.order.serviceList[0].packageList[0].items.push(
                  {
                    count: 1,
                    barcode: null,
                    size: defaultItemSizeItem.itemSize || 'NoPackage',
                    labels: defaultItemSizeItem.labels || [],
                    dimensions: defaultItemSizeItem.dimensions || {},
                    weight: defaultItemSizeItem.weight
                  }
                )
              }

              $scope.identificationOptions = {
                Operation: self.ordersService.buildIdentificationOptions(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings),
              };

              var defaultOperationIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings);

              _.forEach($scope.order.serviceList[0].taskList, (t) => {
                var purpose = t.taskSpec.purpose;
                var identificationsRef = defaultOperationIdentification;
                $scope.onIdentificationsChange(identificationsRef, t);

                // Set tasks default service time
                if (t.taskSpec.purpose === 'Operation') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
                  }
                }
              });

              $scope.setQuotesByDate($scope.selectedDate);

            })
        }

        function _parseMinutesToMilis(minutes) {
          return minutes * 60000;
        }

        $scope._getSubTaskActionsWithDefaults = (subTask) => {
          if (!subTask.actions?.length) return [];

          return subTask.actions.map((a) => {

            if ($scope.cashOnDeliveryActionTypesMap[a.type]) {

              a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
                method: undefined,
                requestAmount: undefined,
                editable: true
              }];
            }
            return a;
          });
        }


        $scope._initOrder = (account, defaultDepot, pricePlanBundle, defaultProgramType) => {
          $scope.order = self.ordersService.getEmptyOperationOrder(account, defaultDepot, pricePlanBundle, defaultProgramType);
          $scope.order.serviceList[0].urgency = 'Other';
          $scope.order.serviceList[0].packageList[0].items = [];
          if ($scope.proxyProviderType !== 'Default') {
            _.forEach($scope.order.serviceList[0].taskList, task => {
              task.taskSpec.useProxyCall = $scope.callContactUsingProxyByDefaultValue;
            })
          }
        }

        function _getServices(order) {
          var services = [{
            serviceType: order.serviceList[0].serviceType,
            tasks: []
          }];
          order.serviceList[0].taskList.forEach((task: TaskModel) => {
            services[0].tasks.push({
              purpose: task.taskSpec.purpose,
              address: task.taskSpec.address
            });
          });
          return services;
        }

        function _setPrice(orderPrice) {
          $scope.orderPrice = orderPrice;
          $scope.paymentMethod = orderPrice ? $scope.billingAccount.defaultPaymentMethod : undefined;
          $scope.paymentMethods = orderPrice ? $scope.billingAccount.paymentMethods : undefined;
          $scope.order.serviceList[0].billing = _.get(orderPrice, 'serviceBillings[0]', undefined);
        }



        $scope.onPackageChange = (packageItem, index) => {
          _.set(packageItem, 'size', packageItem.type);
          _.unset(packageItem, 'type');

          const itemsCopy = angular.copy($scope.order.serviceList[0].packageList[0].items);
          itemsCopy[index] = packageItem;
          $scope.order.serviceList[0].packageList[0].items = itemsCopy;
        }
      }
    })
  }

  importRecurringServices(event?, account?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/import-services-template-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesConstants) {

        $scope.loading = false;
        $scope.accountId = _.get(account, 'id');
        $scope.file = undefined;

        // Init Default Account
        if (account) {
          $scope.favouriteAccountName = _.get(account, 'name');
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope.accountId = _.get(account, 'id');
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onDownloadExample = () => {
          var downloadUrl = deliveriesConstants.importRecurringServicesSampleFileLink;
          var a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-recurring-services-example.xls";
          document.body.appendChild(a);
          a.click();
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;

            self.deliveriesRequestsService.importRecurringServices($scope.file, $scope.accountId)
              .then((response) => {
                self.$mdDialog.hide(response);
              })
              .catch((error) => {
                self.deliveriesAlertsService.uploadError();
                self.$log.error('Failed to upload excel to server', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }


      }
    })
  }

  createRecurringService(event?, serviceType?, accountId?, notBefore?, notAfter?, recurringType?, byWeekDay?, endRecurring?, interval?, zoneId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/create-recurring-service-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, scheduleService: ScheduleService, commonsConstants, tasksConstants, $account) {

        var rrule = require('rrule');

        $scope.serviceType = serviceType;

        $scope.header = 'Create New Recurring ' + serviceType;
        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.purposeToBackgroundColor = tasksConstants.purposeToBackgroundColor;
        $scope.recurringTypes = commonsConstants.rruleTypes;
        $scope.canCreateTag = self.IAMPermissions.hasPermission('infoTags.create');
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.useLegacyServiceTime = self.splitService.getUseLegacyServiceTime();
        $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);
        $scope.byWeekDay = byWeekDay;
        $scope.ignoreTimeForServiceTemplate = true;
        $scope.loading = false;
        $scope.endRecurring = endRecurring;
        $scope.hasInterval = !!interval;

        _.forEach($scope.byWeekDay, (wd) => {
          $scope.days[wd].enabled = true;
        })

        $scope.openSections = {
          Pickup: false,
          Dropoff: true,
          Operation: true
        };

        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };

        $scope.customAddressEnabled = {
          Pickup: false,
          Dropoff: false
        };

        $scope.serviceTime = undefined;
        $scope.customers = {};
        $scope.programTypes = [];

        $scope.isRecurringTypeDisabled = !!recurringType || !!endRecurring;
        $scope.recurringType = !!recurringType ? $scope.recurringTypes.find((r) => {
          return r.type === recurringType;
        }) : $scope.recurringTypes[0];

        $scope.recurringService = {
          // account: undefined,
          programType: undefined,
          eventSchedule: scheduleService.getSchedulePayload(
            (notBefore ? notBefore : self.moment().startOf('day').valueOf()),
            undefined,
            (notBefore ? notBefore : self.moment().startOf('day').valueOf()),
            endRecurring,
            'WEEKLY',
            interval,
            (zoneId || self.splitService.getTimeZone())),
          template: undefined
        };
        $scope.accountId = accountId;

        if ($scope.recurringType?.type !== 'DAILY') {
          const weekDays = _.filter($scope.days, (value, key) => {
            return value.enabled;
          });
          $scope.recurringService.eventSchedule.byWeekDay = _.map(weekDays, 'key');
        }

        if (accountId) {
          $account(accountId).$asyncValue()
            .then((account) => {
              $scope._initAccount(account);
            })
        }

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope._initAccount(account);
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope._loadOrderSettings($scope.recurringService.template.pricePlanType);
        }

        $scope.swapTasks = () => {
          self.ordersService.swapTasks($scope.recurringService.template);
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType?.type === 'WEEKLY') {
            $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);
            if ($scope.recurringService.eventSchedule?.byWeekDay) {
              $scope.recurringService.eventSchedule.byWeekDay.forEach((wd) => {
                $scope.days[wd].enabled = true;
              })
            }
          } else {
            $scope.days = undefined;
            $scope.recurringService.eventSchedule.byWeekDay = [];
          }
        }
        //
        // $scope.onServiceTimeChange = (serviceTime) => {
        //   $scope.serviceTime = serviceTime;
        // }

        $scope.onRangeChange = (from, to) => {
          $scope.recurringService.eventSchedule.startRecurring = from;
          $scope.recurringService.eventSchedule.startTime = from;
          $scope.recurringService.eventSchedule.endTime = to;

          if (!!$scope.recurringService.eventSchedule.endRecurring &&
            $scope.recurringService.eventSchedule.startRecurring > $scope.recurringService.eventSchedule.endRecurring) {
            $scope.recurringService.eventSchedule.endRecurring = undefined;
          }

          self.deliveriesService.setTimesOnDelivery($scope.recurringService.template, from, to);
        }

        $scope.onIgnoreTimeRangeChange = (selectedDate) => {
          $scope.recurringService.eventSchedule.startRecurring = selectedDate;
          $scope.recurringService.eventSchedule.startTime = undefined;
          $scope.recurringService.eventSchedule.endTime = undefined;

          if (!!$scope.recurringService.eventSchedule.endRecurring &&
            $scope.recurringService.eventSchedule.startRecurring > $scope.recurringService.eventSchedule.endRecurring) {
            $scope.recurringService.eventSchedule.endRecurring = undefined;
          }

          if (!$scope.ignoreTimeForServiceTemplate) {
            self.deliveriesService.setTimesOnDelivery($scope.recurringService.template, undefined, undefined);
          }
        }

        $scope.onChangeIgnoreTimeForServiceTemplate = () => {
          $scope.ignoreTimeForServiceTemplate = !$scope.ignoreTimeForServiceTemplate;

          if ($scope.ignoreTimeForServiceTemplate) {
            $scope.recurringService.eventSchedule.startTime = undefined;
            $scope.recurringService.eventSchedule.endTime = undefined;
            self.deliveriesService.setTimesOnDelivery($scope.recurringService.template, undefined, undefined);
          } else {
            const from = notBefore || self.moment($scope.recurringService.eventSchedule.startRecurring).startOf('day').valueOf();
            const to = notAfter || self.moment($scope.recurringService.eventSchedule.startRecurring).endOf('day').valueOf();
            self.deliveriesService.setTimesOnDelivery($scope.recurringService.template, from, to);
          }
        }

        $scope.onTimeTypeChange = (type) => {
          $scope.recurringService.template.type = type;
        }

        $scope.onTaskFromTimeChange = (task, time) => {
          task.taskSpec.notBefore = time;
        }

        $scope.onTaskToTimeChange = (task, time) => {
          task.taskSpec.notAfter = time;
        }

        $scope.onEndRecurringChange = (date) => {
          $scope.recurringService.eventSchedule.endRecurring = date;
        }

        $scope.onTagsChange = (tagNames) => {
          $scope.recurringService.template.tagNames = tagNames;
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];
          var taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
          $scope.customAddressEnabled[taskPurposeToDisableCustom] = false;

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onAddressChange = (address, taskRef, taskIndex) => {
          $scope.recurringService.template.taskList[taskIndex].taskSpec.address = address;
        }

        $scope.onPackageChange = (packageItem, index) => {
          _.set(packageItem, 'size', packageItem.type);
          _.unset(packageItem, 'type');

          const itemsCopy = angular.copy($scope.recurringService.template.packageList[0].items);

          itemsCopy[index] = packageItem;
          $scope.recurringService.template.packageList[0].items = itemsCopy;
        }

        $scope.onSubmit = (form) => {

          if (form.Pickup) {
            form.Pickup.$setSubmitted();
          }
          if (form.Dropoff) {
            form.Dropoff.$setSubmitted();
          }
          if (form.Operation) {
            form.Operation.$setSubmitted();
          }

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              var recurringServiceCopy = angular.copy($scope.recurringService);

              if ($scope.recurringType) {
                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment(recurringServiceCopy.eventSchedule.startRecurring).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                recurringServiceCopy.eventSchedule.rrule = roleTest.toString();
                recurringServiceCopy.eventSchedule.interval = 1;
                recurringServiceCopy.eventSchedule.freq = $scope.recurringType.value.substr(6);

                recurringServiceCopy.eventSchedule.byWeekDay = [];
                if (recurringServiceCopy.eventSchedule.freq && !_.isEqual(recurringServiceCopy.eventSchedule.freq, 'DAILY')) {
                  _.forOwn($scope.days, (value, key) => {
                    if (value.enabled) {
                      recurringServiceCopy.eventSchedule.byWeekDay.push(key);
                    }
                  })
                }

              }

              // if ($scope.serviceTime) {
              //   _.forEach(recurringServiceCopy.template.taskList, (t) => {
              //     _.set(t, 'taskSpec.serviceTime', ($scope.serviceTime * 60000)) // minutes to mili
              //   })
              // }

              self.$mdDialog.hide(recurringServiceCopy);
            }
          }
        }

        $scope._initAccount = (account: AccountModel) => {
          $scope.pricePlanBundle = undefined;
          $scope.billingAccount = undefined;
          $scope.programTypes = [];

          $scope.recurringService.accountId = account?.id;
          $scope.recurringService.account = account;

          if (account) {
            $scope.account = account;
            $scope.loading = true;
            return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
              .then((pricePlanBundle) => {
                $scope.programTypes = _.filter(pricePlanBundle.entryList, 'enabled');

                var programTypeId = _.get($scope.programTypes, '[0].type')
                $scope.recurringService.template = account ?
                  $scope._getEmptyServiceByType(
                    account,
                    programTypeId,
                    (notBefore ? notBefore : self.moment().startOf('day').valueOf()),
                    (notAfter ? notAfter : self.moment().endOf('day').set({
                      'minute': 45,
                      'second': 0,
                      'millisecond': 0
                    }).valueOf())
                  ) :
                  undefined;

                if ($scope.recurringService.template) {
                  $scope.recurringService.template.type = 'TimeSlot';
                }

                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.recurringService.accountId, $scope.serviceType || 'Delivery');
              })
              .then((defaultPricePlanTypeByServiceType) => {
                $scope.recurringService.template.pricePlanType = _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                $scope._loadOrderSettings($scope.recurringService.template.pricePlanType);
              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }

        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          var quoteTypes = ['TimeSlot', 'PerTask'];

          self.ordersService.getOrderSettings($scope.recurringService.accountId, $scope.recurringService.template.serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;


              $scope.packageSizes = serviceRef.itemSizeList;

              $scope.subTaskOptionsMap = {
                [TaskPurposeType.Pickup]: [],
                [TaskPurposeType.Dropoff]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(TaskPurposeType.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(TaskPurposeType.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;
              $scope.recurringService.template.vehicleType = _.get(serviceRef, 'defaultVehicle');

              _.forEach($scope.recurringService.template.taskList, (t) => {
                t.subTasks = [];
                serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                  if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                    t.subTasks.push(defaultSubTask);
                  }
                })

                t.subTasks?.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })
              })


              if (!$scope.recurringService.template.packageList[0].items.length) {
                var defaultItemSizeItem = _.find($scope.packageSizes, (p) => {
                  return p.itemSize === serviceRef.defaultItemSize;
                });
                $scope.recurringService.template.packageList[0].items.push(
                  {
                    count: 1,
                    barcode: null,
                    size: defaultItemSizeItem.itemSize || 'NoPackage',
                    labels: defaultItemSizeItem.labels || [],
                    dimensions: defaultItemSizeItem.dimensions || {},
                    weight: defaultItemSizeItem.weight
                  }
                )
              }

              $scope.identificationOptions = {
                Pickup: self.ordersService.buildIdentificationOptions(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings),
                Dropoff: self.ordersService.buildIdentificationOptions(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings),
              };

              var defaultPickupIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings);

              var defaultDropoffIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings);

              _.forEach($scope.recurringService.template.taskList, (t) => {
                var purpose = t.taskSpec.purpose;
                var identificationsRef = purpose === 'Pickup' ? defaultPickupIdentification : defaultDropoffIdentification;
                $scope.onIdentificationsChange(identificationsRef, t);

                // Set tasks default service time
                if (t.taskSpec.purpose === 'Pickup') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
                  }
                }
                if (t.taskSpec.purpose === 'Dropoff') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
                  }
                }
                if (t.taskSpec.purpose === 'Operation') {
                  if ($scope.useLegacyServiceTime) {
                    t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime.generatedTotalTime', 0);
                  } else {
                    t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {})
                  }
                }
              });

            })
        }

        $scope._getEmptyServiceByType = (account, programTypeId, notBefore, notAfter) => {
          return $scope.serviceType === 'Delivery' ?
            self.ordersService.getEmptyDeliveryService(account, undefined, programTypeId, notBefore, notAfter) :
            self.ordersService.getEmptyOperationalService(account, undefined, programTypeId, notBefore, notAfter);
        }


      }
    })
  }

  editRecurringService(event?, recurringService?, isDuplicate?, ignoreSetService?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/create-recurring-service-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, commonsConstants, tasksConstants, $customers, deliveriesService) {

        $scope.useLegacyServiceTime = self.splitService.getUseLegacyServiceTime();

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          var quoteTypes = ['TimeSlot', 'PerTask'];

          self.ordersService.getOrderSettings($scope.recurringService.accountId, $scope.recurringService.template.serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;


              $scope.packageSizes = serviceRef.itemSizeList;

              $scope.subTaskOptionsMap = {
                [TaskPurposeType.Pickup]: [],
                [TaskPurposeType.Dropoff]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(TaskPurposeType.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(TaskPurposeType.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;
              $scope.recurringService.template.vehicleType = _.get(serviceRef, 'defaultVehicle');

              _.forEach($scope.recurringService.template.taskList, (t) => {
                t.subTasks = [];
                serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                  if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                    t.subTasks.push(defaultSubTask);
                  }
                })

                t.subTasks?.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })
              })


              if (!$scope.recurringService.template.packageList[0].items.length) {
                var defaultItemSizeItem = _.find($scope.packageSizes, (p) => {
                  return p.itemSize === serviceRef.defaultItemSize;
                });
                $scope.recurringService.template.packageList[0].items.push(
                  {
                    count: 1,
                    barcode: null,
                    size: defaultItemSizeItem.itemSize || 'NoPackage',
                    labels: defaultItemSizeItem.labels || [],
                    dimensions: defaultItemSizeItem.dimensions || {},
                    weight: defaultItemSizeItem.weight
                  }
                )
              }

              $scope.identificationOptions = {
                Pickup: self.ordersService.buildIdentificationOptions(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings),
                Dropoff: self.ordersService.buildIdentificationOptions(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings),
              };

              var defaultPickupIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.pickupPodSettings, serviceRef.pickupPodFillRequiredSettings);

              var defaultDropoffIdentification = self.ordersService.buildDefaultIdentifications(serviceRef.dropoffPodSettings, serviceRef.dropoffPodFillRequiredSettings);

              _.forEach($scope.recurringService.template.taskList, (t) => {
                var purpose = t.taskSpec.purpose;
                var identificationsRef = purpose === 'Pickup' ? defaultPickupIdentification : defaultDropoffIdentification;
                $scope.onIdentificationsChange(identificationsRef, t);
              });

            })
        }

        $scope._initAccount = (account, setService) => {
          $scope.pricePlanBundle = undefined;
          $scope.billingAccount = undefined;
          $scope.programTypes = [];

          $scope.recurringService.accountId = account?.id;

          if (account) {
            $scope.loading = true;
            return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
              .then((pricePlanBundle) => {
                $scope.programTypes = _.filter(pricePlanBundle.entryList, 'enabled');

                if (setService) {
                  var programTypeId = _.get($scope.programTypes, '[0].type')
                  $scope.recurringService.template = account ?
                    $scope._getEmptyServiceByType(
                      account,
                      programTypeId,
                      ($scope.recurringService.template?.notBefore ? $scope.recurringService.template.notBefore : self.moment().startOf('day').valueOf()),
                      ($scope.recurringService.template?.notAfter ? $scope.recurringService.template.notAfter : self.moment().endOf('day').set({
                        'minute': 45,
                        'second': 0,
                        'millisecond': 0
                      }).valueOf())
                    ) :
                    undefined;
                  if ($scope.recurringService.template) {
                    $scope.recurringService.template.type = 'TimeSlot';
                  }
                }
                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.recurringService.accountId, $scope.serviceType || 'Delivery');
              })
              .then((defaultPricePlanTypeByServiceType) => {
                $scope.recurringService.template.pricePlanType = _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                $scope._loadOrderSettings($scope.recurringService.template.pricePlanType);

              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          } else {
            $scope.loading = false;
          }

        }

        var rrule = require('rrule');

        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.purposeToBackgroundColor = tasksConstants.purposeToBackgroundColor;
        $scope.recurringTypes = commonsConstants.rruleTypes;
        $scope.canCreateTag = self.IAMPermissions.hasPermission('infoTags.create');
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.loading = true;
        $scope.customers = {};
        $scope.openSections = {
          Pickup: true,
          Dropoff: true,
          Operation: true
        };

        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };

        $scope.customAddressEnabled = {
          Pickup: false,
          Dropoff: false
        };

        $scope.recurringService = angular.copy(recurringService);
        $scope.serviceType = _.get(recurringService, 'template.serviceType');
        $scope.header = (isDuplicate ? 'Duplicate Recurring ' : 'Edit Recurring ') + $scope.serviceType;

        $scope.programTypes = [];

        // _.forEach(recurringService.template.taskList, (t) => {
        //   if (_.get(t, 'taskSpec.serviceTime')) {
        //     $scope.serviceTime = (t.taskSpec.serviceTime / 60000) // mili to minutes
        //   }
        // })

        $scope.recurringType = $scope.recurringTypes.find((r) => {
          return r.type === recurringService.eventSchedule.freq;
        }) || $scope.recurringTypes[0];

        if ($scope.recurringType.type === 'WEEKLY') {
          $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);

          if ($scope.recurringService.eventSchedule?.byWeekDay) {
            $scope.recurringService.eventSchedule.byWeekDay.forEach((wd) => {
              $scope.days[wd].enabled = true;
            })
          }
        }


        if ($scope.recurringType?.type === 'WEEKLY') {
          const weekDays = _.filter($scope.days, (value, key) => {
            return value.enabled;
          });
          $scope.recurringService.eventSchedule.byWeekDay = _.map(weekDays, 'key');
        }

        const customerIds = _.chain(recurringService.template.taskList)
          .filter((task: TaskModel) => {
            return _.get(task.taskSpec, 'locationDetails.locationType') === "CUSTOMER"
          })
          .map((filteredTask) => {
            return filteredTask.taskSpec.locationDetails.id;
          })
          .value();

        if (customerIds?.length) {
          $customers().$asyncValues(customerIds)
            .then((customers) => {
              const pickup = deliveriesService.getPickups(recurringService.template)[0],
                dropoff = deliveriesService.getDropoffs(recurringService.template)[0];

              $scope.customers = {
                Pickup: _getCustomerByTask(pickup, customers),
                Dropoff: _getCustomerByTask(dropoff, customers)
              };
            })
        }

        function _getCustomerByTask(task, customersList) {
          if ((!customersList || !customersList.length) || (!task || !task.taskSpec.locationDetails)) {
            return undefined;
          }
          return _.find(customersList, (c) => {
            return c.id === _.get(task.taskSpec, 'locationDetails.id');
          });
        }

        $scope._initAccount(recurringService.accountReference);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account) => {
          $scope._initAccount(account, !ignoreSetService);
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
        }

        $scope.swapTasks = () => {
          self.ordersService.swapTasks($scope.recurringService.template);
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType?.type === 'WEEKLY') {
            $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);
            if ($scope.recurringService.eventSchedule?.byWeekDay) {
              $scope.recurringService.eventSchedule.byWeekDay.forEach((wd) => {
                $scope.days[wd].enabled = true;
              })
            }
          } else {
            $scope.days = undefined;
            $scope.recurringService.eventSchedule.byWeekDay = [];
          }
        }

        // $scope.onServiceTimeChange = (serviceTime) => {
        //   $scope.serviceTime = serviceTime;
        // }

        $scope.onRangeChange = (from, to) => {
          $scope.recurringService.eventSchedule.startRecurring = from; //TODO Remove?
          $scope.recurringService.eventSchedule.startTime = from;
          $scope.recurringService.eventSchedule.endTime = to;

          if (!!$scope.recurringService.eventSchedule.endRecurring &&
            $scope.recurringService.eventSchedule.startRecurring > $scope.recurringService.eventSchedule.endRecurring) {
            $scope.recurringService.eventSchedule.endRecurring = undefined;
          }

          self.deliveriesService.setTimesOnDelivery($scope.recurringService.template, from, to);
        }

        $scope.onEndRecurringChange = (date) => {
          $scope.recurringService.eventSchedule.endRecurring = date;
        }

        $scope.onTagsChange = (tagNames) => {
          $scope.recurringService.template.tagNames = tagNames;
        }

        $scope.onTimeTypeChange = (type) => {
          $scope.recurringService.template.type = type;
        }

        $scope.onTaskFromTimeChange = (task, time) => {
          task.taskSpec.notBefore = time;
        }

        $scope.onTaskToTimeChange = (task, time) => {
          task.taskSpec.notAfter = time;
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];
          var taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
          $scope.customAddressEnabled[taskPurposeToDisableCustom] = false;

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onAddressChange = (address, taskRef, taskIndex) => {
          $scope.recurringService.template.taskList[taskIndex].taskSpec.address = address;
        }

        $scope.onPackageChange = (packageItem, index) => {
          _.set(packageItem, 'size', packageItem.type);
          _.unset(packageItem, 'type');

          const itemsCopy = angular.copy($scope.recurringService.template.packageList[0].items);

          itemsCopy[index] = packageItem;
          $scope.recurringService.template.packageList[0].items = itemsCopy;
        }

        $scope.onSubmit = (form) => {
          if (form.Pickup) {
            form.Pickup.$setSubmitted();
          }
          if (form.Dropoff) {
            form.Dropoff.$setSubmitted();
          }
          if (form.Operation) {
            form.Operation.$setSubmitted();
          }

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              var recurringServiceCopy = angular.copy($scope.recurringService);

              if ($scope.recurringType) {
                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment(recurringServiceCopy.eventSchedule.startRecurring).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                recurringServiceCopy.eventSchedule.rrule = roleTest.toString();
                recurringServiceCopy.eventSchedule.interval = 1;
                recurringServiceCopy.eventSchedule.freq = $scope.recurringType.value.substr(6);

                recurringServiceCopy.eventSchedule.byWeekDay = [];
                _.forOwn($scope.days, (value, key) => {
                  if (value.enabled) {
                    recurringServiceCopy.eventSchedule.byWeekDay.push(key);
                  }
                })

              }
              //
              // if ($scope.serviceTime) {
              //   _.forEach(recurringServiceCopy.template.taskList, (t) => {
              //     _.set(t, 'taskSpec.serviceTime', ($scope.serviceTime * 60000)) // minutes to mili
              //   })
              // }

              self.$mdDialog.hide(recurringServiceCopy);
            }
          }
        }

        $scope._getEmptyServiceByType = (account, programTypeId, notBefore, notAfter) => {
          return $scope.serviceType === 'Delivery' ?
            self.ordersService.getEmptyDeliveryService(account, undefined, programTypeId, notBefore, notAfter) :
            self.ordersService.getEmptyOperationalService(account, undefined, programTypeId, notBefore, notAfter);
        }


      }
    })
  }

  editServiceTimeWindow(serviceId?, toDate?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-service-time-window-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $delivery) {

        var yearRef = self.moment(toDate).get('year');
        var monthRef = self.moment(toDate).get('month');
        var dateRef = self.moment(toDate).get('date');

        $scope.service = undefined;
        $scope.isShouldSendSms = false;

        $scope.loading = true
        $delivery(serviceId).$asyncValue()
          .then((service) => {
            const serviceCopy = angular.copy(service);
            serviceCopy.notBefore = self.moment(serviceCopy.notBefore).set({
              'year': yearRef,
              'month': monthRef,
              'date': dateRef
            }).valueOf();
            serviceCopy.notAfter = self.moment(serviceCopy.notAfter).set({
              'year': yearRef,
              'month': monthRef,
              'date': dateRef
            }).valueOf();

            $scope.service = serviceCopy;
          })
          .catch((error) => {
            self.$log.error('Failed to get delivery from server' + error);
          })
          .finally(() => {
            $scope.loading = false;
          })

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onFromTimeChange = (notBefore) => {
          $scope.service.notBefore = notBefore;
        }

        $scope.onToTimeChange = (notAfter) => {
          $scope.service.notAfter = notAfter;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              _.forEach($scope.service.taskList, (t) => {
                t.taskSpec.notBefore = angular.copy($scope.service.notBefore);
                t.taskSpec.notAfter = angular.copy($scope.service.notAfter);
              })
              var payload = {
                service: $scope.service,
                isShouldSendSms: $scope.isShouldSendSms
              }
              self.$mdDialog.hide(payload);
            }
          }
        }


      }
    })
  }

  editServiceBilling(serviceId?, billing?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-service-pricing-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, deliveriesConstants) {

        $scope.billing = angular.copy(billing);
        $scope.serviceId = serviceId;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.billing);
            }
          }
        }

      },
    })
  }

  selectService(serviceIds?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/select-service-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $deliveries) {

        $scope.services = [];
        $scope.selectedIds = []; // using ids but selecting only one service.

        $scope.loading = true
        $deliveries().$asyncValues(serviceIds)
          .then((services) => {
            $scope.services = services;
          })
          .catch((error) => {
            self.$log.error('Failed to get delivery from server' + error);
          })
          .finally(() => {
            $scope.loading = false;
          })

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onSelectedServiceChange = (selectedIds) => {
          $scope.selectedIds = selectedIds;
        }

        $scope.submit = () => {
          if ($scope.selectedIds[0]) {
            var selectedService = _.find($scope.services, (s) => {
              return s.id === $scope.selectedIds[0];
            })
            self.$mdDialog.hide(selectedService);
          }
        }


      }
    })
  }

  bulkEditLocation(serviceIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/services-bulk-edit-location.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.serviceIds = serviceIds;

        $scope.sections = {
          pickupTaskSection: false,
          destinationTaskSection: false
        }

        $scope.payload = {
          pickupTaskSpec: {
            address: {},
            contact: {},
            locationDetails: {
              locationType: "ACCOUNT"
            }
          },
          destinationTaskSpec: {
            address: {},
            contact: {},
            locationDetails: {
              locationType: "ACCOUNT"
            }
          },
          rePrice: false,
          sendSms: false,
          updateOrder: false
        }

        $scope.onSectionsChange = (sections) => {
          $scope.sectionsCopy = angular.copy(sections);
          $scope.sections = $scope.sectionsCopy;
        }

        $scope.onPayloadChange = (payload) => {
          $scope.payloadCopy = angular.copy(payload);
          $scope.payload = $scope.payloadCopy;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if (!$scope.sections.pickupTaskSection) {
                _.unset($scope.payload, 'pickupTaskSpec');
              }
              if (!$scope.sections.destinationTaskSection) {
                _.unset($scope.payload, 'destinationTaskSpec');
              }
              self.$mdDialog.hide($scope.payload);
            }
          }
        }
      }
    })
  }

  editIdentification(service, taskId, identification, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-identification-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false
        $scope.identification = angular.copy(identification);
        $scope.serviceCopy = angular.copy(service);

        $scope.taskIndex = _.findIndex(service.taskList, (t: any) => {
          return t.id === taskId;
        })
        $scope.fileIdentification = ['signature', 'visitSummary', 'photographIdCard', 'photographPerson', 'leaveNextToDoor'];
        $scope.uploadFileNeeded = _.includes($scope.fileIdentification, identification);
        $scope.isDone = {
          value: $scope.serviceCopy.taskList[$scope.taskIndex].taskSpec.identifications[identification + 'Done'] || false
        };

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onUpdate = () => {
          $scope.loading = true;

          if ($scope.uploadFileNeeded) {
            self.attachmentsService.addAttachment($scope.file)
              .then((response: any) => {
                if ($scope.taskIndex > -1) {
                  $scope.serviceCopy.taskList[$scope.taskIndex].taskSpec.identifications[identification + 'Url'] = response.url;
                  $scope.serviceCopy.taskList[$scope.taskIndex].taskSpec.identifications[identification + 'BlobName'] = response.name;
                }
                $scope.updateService($scope.serviceCopy);
              })
          } else {
            $scope.serviceCopy.taskList[$scope.taskIndex].taskSpec.identifications[identification + 'Done'] = $scope.isDone.value;
            $scope.updateService($scope.serviceCopy);
          }
        }

        $scope.updateService = (service) => {
          self.$delivery(service.id).$update(service, {}, {})
            .then((updatedService) => {
              self.$mdDialog.hide(updatedService);
            })
            .catch((error) => {
              self.deliveriesAlertsService.uploadError();
              self.$log.error('Failed to upload excel to server, ' +
                'deliveriesFileDropUpload@uploadFiles' + error);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }


      }
    })
  }

  editLocation(serviceId, taskSpec, orderId?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/service-task-location-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.payload = {
          taskSpec: angular.copy(taskSpec),
          updateOrder: false,
          sendSms: false,
          rePrice: false
        };
        $scope.orderId = orderId;


        // Init Form
        $scope.loading = true;
        self.deliveriesRequestsService.getEditOrderOptions(serviceId)
          .then((orderOptions: EditOrderOptionsModel) => {
            $scope.orderOptions = orderOptions;
          })
          .catch((error) => {
            self.$log.error('Failed to get order options', error);
          })
          .finally(() => {
            $scope.loading = false;
          })

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onTaskSpecChange = (taskSpec) => {
          $scope.payload.taskSpec = taskSpec;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.payload);
            }
          }
        }


      }
    })
  }

  editReferenceIds(referenceIds, orderId?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/services-task-edit-reference-ids.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.payload = {
          referenceIds: referenceIds ? angular.copy(referenceIds) : [],
          updateOrder: undefined
        };
        $scope.orderId = orderId;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onReferenceIdsChange = (referenceIds) => {
          $scope.payload.referenceIds = referenceIds;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.payload);
            }
          }
        }


      }
    })
  }

  editExtraInfo(extraInfo, $event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/services-task-edit-extra-info.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.extraInfo = angular.copy(extraInfo);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onExtraInfoChange = (extraInfo) => {
          $scope.payload.extraInfo = extraInfo;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.extraInfo);
            }
          }
        }


      }
    })
  }

  getAttachment(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/get-attachment-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onSubmit = () => {
          $scope.loading = true;
          self.attachmentsService.addAttachment($scope.file)
            .then((response) => {
              self.$mdDialog.hide(response);
            })
        }

      }
    })
  }

  dispatchStepExternal(fulfillmentId, stepId, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/dispatch-step-external.html').default,
      controller: function ($scope, $steps) {

        $scope.stepsRef = $steps();
        $scope.isOnDemand = false;
        $scope.tplProviders = self.splitService.getSupportedThreePlProviders();
        $scope.minDate = self.moment().valueOf();

        $scope.isLoadingQuotes = false;
        // $scope.selectedTplProvider = ThreePLProviderType.Uber;
        if ($scope.tplProviders?.length) {
          $scope.selectedTplProvider = $scope.tplProviders[0];
        }
        $scope.date = self.moment().valueOf();
        $scope.notBefore = self.moment().valueOf();
        $scope.notAfter = self.moment().endOf('day').valueOf();
        $scope.selectedQuote = undefined;
        $scope.quotes = undefined;
        $scope.threePlExtraData = {};
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.getQuotes = () => {
          if (!$scope.notBefore || !$scope.notAfter || !$scope.selectedTplProvider) {
            return;
          }

          $scope.quotes = undefined;
          $scope.isLoadingQuotes = true;

          self.fulfillmentService.getStepDispatchTimeRanges(fulfillmentId, $scope.step.id, 'ThirdParty', $scope.selectedTplProvider, !$scope.isOnDemand ? $scope.notBefore : undefined, !$scope.isOnDemand ? $scope.notAfter : undefined)
            .then((res: any) => {
              $scope.quotes = res.stepDispatchOptions;
            })
            .finally(() => {
              $scope.isLoadingQuotes = false;
            });
        }

        $scope.onChangeIsOnDemand = () => {
          $scope.isOnDemand = !$scope.isOnDemand;
          $scope.getQuotes();
        }

        $scope.stepsRef.$asyncValues([stepId])
          .then((res) => {
            $scope.step = res[0];
            $scope.getQuotes();
          })

        $scope.onTplProviderSelect = (selectedTplProvider) => {
          $scope.selectedTplProvider = selectedTplProvider;

          $scope.threePlExtraData = {};
          $scope.getQuotes();
        }

        $scope.onThreePlExtraDataChange = (threePlExtraData) => {
          $scope.threePlExtraData = angular.copy(threePlExtraData);
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.date = selectedDate;
          $scope.notBefore = self.moment(selectedDate).startOf('day').valueOf();
          $scope.notAfter = self.moment(selectedDate).endOf('day').valueOf();
          $scope.getQuotes();
        }

        $scope.onTimeChange = (selectedTime, isFrom) => {
          if (isFrom) {
            $scope.notBefore = selectedTime;
          } else {
            $scope.notAfter = selectedTime;
          }
          $scope.getQuotes();
        }

        $scope.onSelectQuote = (selectedQuote) => {
          $scope.selectedQuote = selectedQuote;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.selectedTplProvider === 'Contractor') {
                $scope.threePlExtraData.type = $scope.selectedTplProvider;
                $scope.selectedQuote.threePlExtraData = $scope.threePlExtraData;
              }
              self.$mdDialog.hide($scope.selectedQuote);
            } else {
              self.fulfillmentAlertsService.dispatchStepRequiredError();
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  unlinkRelatedTaskConfirm(service, relation, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/unlink-related-task-confirm-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.service = service;
        $scope.relation = relation;

        ///////////////////////////////////////////////////////////

        $scope.confirm = (form) => {
          self.$mdDialog.hide();
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

      }
    })
  }

  viewServiceIdentification(service: Service) {
    const self = this;
    this.$mdDialog.show({
      template: require('./../views/tmpl/service-identifications.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.service = service;

        $scope.attachments = [];
        $scope.loading = true;

        $scope._getAttachments = (task: TaskModel, taskType: any): string[] => {

          let attachments = [];

          Object.entries(task.taskSpec?.identifications).forEach(([key, value], index) => {
            if (key.includes('BlobName')) {
              attachments.push({id: value, name: key, url: undefined, purpose: taskType})
            }
          });

          return attachments;
        }

        service.taskList.forEach((task) => {
          $scope.attachments = $scope.attachments.concat($scope._getAttachments(task, task.taskSpec.purpose));
        })

        const blobNamesArray = $scope.attachments.map(a => a.id);

        if (blobNamesArray.length) {
          self.attachmentsService.getAttachmentsUrls(blobNamesArray)
            .then((attachmentsUrls: any[]) => {
              attachmentsUrls.forEach((a) => {
                const attachmentIndex = $scope.attachments.findIndex(attachment => attachment.id === a.name);
                $scope.attachments[attachmentIndex].url = a.url;
              })

              $scope.loading = false;

            })
        }

        $scope.cancel = () => {
          $mdDialog.cancel();
        };
      }
    });

  }

  editMissingItemsByPackageItem(packageItem: any, missingItem: MissingItemModel) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/edit-missing-items-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.packageItem = angular.copy(packageItem);
        $scope.missingItem = angular.copy(missingItem);

        $scope.attachments = [];

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onReset = () => {
          const missingItemCopy = angular.copy($scope.missingItem);
          missingItemCopy.dataList = missingItemCopy.dataList.map((data) => {
            return $scope._getMissingItemDataItem();
          })

          $scope.missingItem = missingItemCopy;
        };

        $scope.onAddMissingItemData = () => {
          const missingItemData: MissingItemDataModel = $scope._getMissingItemDataItem();
          const missingItemCopy = angular.copy($scope.missingItem);
          missingItemCopy.dataList = missingItemCopy.dataList.concat(missingItemData);

          $scope.missingItem = missingItemCopy;
        };

        $scope.onRemoveMissingItemData = (index: number, form) => {
          const missingItemCopy = angular.copy($scope.missingItem);
          missingItemCopy.dataList.splice(index, 1)

          form.$removeControl(form[`quantity${index}`]);
          form.$removeControl(form[`reason${index}`]);

          $scope.missingItem = missingItemCopy;
        };

        $scope.onChangeMissingItemData = (missingItemData: MissingItemDataModel, index: number) => {
          if (index > -1) {
            const missingItemCopy = angular.copy($scope.missingItem);
            missingItemCopy.dataList[index] = missingItemData;

            $scope.missingItem = missingItemCopy;
          }
        };

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.missingItem);
            }
          }
        };

        $scope._getMissingItemDataItem = (form): MissingItemDataModel => {
          return {
            reasonId: undefined,
            reason: undefined,
            externalId: undefined,
            description: undefined,
            quantity: undefined,
            comment: undefined,
            updatedBy: undefined,
            updatedAt: undefined,
          }
        };

      }
    });

  }

  editPackages(packageList: any, packageSizes?, defaultItemSize?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/edit-packages-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.packageList = angular.copy(packageList);
        $scope.packageSizes = angular.copy(packageSizes);
        $scope.defaultItemSize = defaultItemSize;

        $scope.attachments = [];

        self.$timeout(0).then(() => {
          $scope.expendAll = true;
        })

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onReset = () => {
          $scope.packageList = angular.copy(packageList);
          $scope.expendAll = false;
        };

        $scope.addPackage = () => {
          $scope.packageList[0].items.push(createNewPackageItem(packageSizes, $scope.defaultItemSize));
        }

        $scope.onPackageChange = (packageItem, index) => {
          $scope.packageList[0].items = replacePackageItem($scope.packageList[0].items, packageItem, index);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.packageList);
            } else {
              $scope.expendAll = true;
            }
          }
        };

      }
    });

  }

}

angular
  .module('bringoz.admin.deliveries')
  .service('deliveriesDialogService', DeliveriesDialogService);
